window.jerseyData = {
  "afghanistan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/afghanistan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/afghanistan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/afghanistan/flag.png",
    "nom_fr": "Afghanistan",
    "nom_en": "Afghanistan",
    "nom_de": "Afghanistan",
    "nom_es": "Afganistán",
    "nom_pt": "Afeganistão",
    "nom_it": "Afghanistan",
    "nom_nl": "Afghanistan",
    "nom_sv": "Afghanistan",
    "nom_da": "Afghanistan",
    "nom_no": "Afghanistan",
    "nom_fi": "Afganistan"
  },
  "albania": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/albania/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/albania/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/albania/flag.png",
    "nom_fr": "Albanie",
    "nom_en": "Albania",
    "nom_de": "Albanien",
    "nom_es": "Albania",
    "nom_pt": "Albânia",
    "nom_it": "Albania",
    "nom_nl": "Albanië",
    "nom_sv": "Albanien",
    "nom_da": "Albanien",
    "nom_no": "Albania",
    "nom_fi": "Albania"
  },
  "algeria": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/algeria/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/algeria/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/algeria/flag.png",
    "nom_fr": "Algérie",
    "nom_en": "Algeria",
    "nom_de": "Algerien",
    "nom_es": "Argelia",
    "nom_pt": "Argélia",
    "nom_it": "Algeria",
    "nom_nl": "Algerije",
    "nom_sv": "Algeriet",
    "nom_da": "Algeriet",
    "nom_no": "Algerie",
    "nom_fi": "Algeria"
  },
  "alsace": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/alsace/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/alsace/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/alsace/flag.png",
    "nom_fr": "Alsace",
    "nom_en": "Alsace",
    "nom_de": "Elsass",
    "nom_es": "Alsacia",
    "nom_pt": "Alsácia",
    "nom_it": "Alsazia",
    "nom_nl": "Elzas",
    "nom_sv": "Alsace",
    "nom_da": "Alsace",
    "nom_no": "Alsace",
    "nom_fi": "Alsace"
  },
  "andorra": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/andorra/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/andorra/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/andorra/flag.png",
    "nom_fr": "Andorre",
    "nom_en": "Andorra",
    "nom_de": "Andorra",
    "nom_es": "Andorra",
    "nom_pt": "Andorra",
    "nom_it": "Andorra",
    "nom_nl": "Andorra",
    "nom_sv": "Andorra",
    "nom_da": "Andorra",
    "nom_no": "Andorra",
    "nom_fi": "Andorra"
  },
  "angola": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/angola/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/angola/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/angola/flag.png",
    "nom_fr": "Angola",
    "nom_en": "Angola",
    "nom_de": "Angola",
    "nom_es": "Angola",
    "nom_pt": "Angola",
    "nom_it": "Angola",
    "nom_nl": "Angola",
    "nom_sv": "Angola",
    "nom_da": "Angola",
    "nom_no": "Angola",
    "nom_fi": "Angola"
  },
  "anguilla": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/anguilla/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/anguilla/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/anguilla/flag.png",
    "nom_fr": "Anguilla",
    "nom_en": "Anguilla",
    "nom_de": "Anguilla",
    "nom_es": "Anguila",
    "nom_pt": "Anguila",
    "nom_it": "Anguilla",
    "nom_nl": "Anguilla",
    "nom_sv": "Anguilla",
    "nom_da": "Anguilla",
    "nom_no": "Anguilla",
    "nom_fi": "Anguilla"
  },
  "antigua": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/antigua/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/antigua/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/antigua/flag.png",
    "nom_fr": "Antigua-et-Barbuda",
    "nom_en": "Antigua and Barbuda",
    "nom_de": "Antigua und Barbuda",
    "nom_es": "Antigua y Barbuda",
    "nom_pt": "Antígua e Barbuda",
    "nom_it": "Antigua e Barbuda",
    "nom_nl": "Antigua e Barbuda",
    "nom_sv": "Antigua och Barbuda",
    "nom_da": "Antigua og Barbuda",
    "nom_no": "Antigua og Barbuda",
    "nom_fi": "Antigua ja Barbuda"
  },
  "argentina": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/argentina/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/argentina/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/argentina/flag.png",
    "nom_fr": "Argentine",
    "nom_en": "Argentina",
    "nom_de": "Argentinien",
    "nom_es": "Argentina",
    "nom_pt": "Argentina",
    "nom_it": "Argentina",
    "nom_nl": "Argentinië",
    "nom_sv": "Argentina",
    "nom_da": "Argentina",
    "nom_no": "Argentina",
    "nom_fi": "Argentiina"
  },
  "armenia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/armenia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/armenia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/armenia/flag.png",
    "nom_fr": "Arménie",
    "nom_en": "Armenia",
    "nom_de": "Armenien",
    "nom_es": "Armenia",
    "nom_pt": "Arménia",
    "nom_it": "Armenia",
    "nom_nl": "Armenië",
    "nom_sv": "Armenien",
    "nom_da": "Armenien",
    "nom_no": "Armenia",
    "nom_fi": "Armenia"
  },
  "australia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/australia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/australia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/australia/flag.png",
    "nom_fr": "Australie",
    "nom_en": "Australia",
    "nom_de": "Australien",
    "nom_es": "Australia",
    "nom_pt": "Austrália",
    "nom_it": "Australia",
    "nom_nl": "Australië",
    "nom_sv": "Australien",
    "nom_da": "Australien",
    "nom_no": "Australia",
    "nom_fi": "Australia"
  },
  "austria": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/austria/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/austria/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/austria/flag.png",
    "nom_fr": "Autriche",
    "nom_en": "Austria",
    "nom_de": "Österreich",
    "nom_es": "Austria",
    "nom_pt": "Áustria",
    "nom_it": "Austria",
    "nom_nl": "Oostenrijk",
    "nom_sv": "Österrike",
    "nom_da": "Østrig",
    "nom_no": "Østerrike",
    "nom_fi": "Itävalta"
  },
  "auvergne": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/auvergne/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/auvergne/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/auvergne/flag.png",
    "nom_fr": "Auvergne",
    "nom_en": "Auvergne",
    "nom_de": "Auvergne",
    "nom_es": "Auvernia",
    "nom_pt": "Alvernha",
    "nom_it": "Alvernia",
    "nom_nl": "Auvergne",
    "nom_sv": "Auvergne",
    "nom_da": "Auvergne",
    "nom_no": "Auvergne",
    "nom_fi": "Auvergne"
  },
  "azerbaijan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/azerbaijan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/azerbaijan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/azerbaijan/flag.png",
    "nom_fr": "Azerbaïdjan",
    "nom_en": "Azerbaijan",
    "nom_de": "Aserbaidschan",
    "nom_es": "Azerbaiyán",
    "nom_pt": "Azerbaijão",
    "nom_it": "Azerbaigian",
    "nom_nl": "Azerbeidzjan",
    "nom_sv": "Azerbajdzjan",
    "nom_da": "Aserbajdsjan",
    "nom_no": "Aserbajdsjan",
    "nom_fi": "Azerbaidžan"
  },
  "bahamas": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bahamas/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bahamas/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bahamas/flag.png",
    "nom_fr": "Bahamas",
    "nom_en": "Bahamas",
    "nom_de": "Bahamas",
    "nom_es": "Bahamas",
    "nom_pt": "Bahamas",
    "nom_it": "Bahamas",
    "nom_nl": "Bahama's",
    "nom_sv": "Bahamas",
    "nom_da": "Bahamas",
    "nom_no": "Bahamas",
    "nom_fi": "Bahama"
  },
  "bahrain": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bahrain/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bahrain/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bahrain/flag.png",
    "nom_fr": "Bahreïn",
    "nom_en": "Bahrain",
    "nom_de": "Bahrain",
    "nom_es": "Baréin",
    "nom_pt": "Bahrein",
    "nom_it": "Bahrein",
    "nom_nl": "Bahrein",
    "nom_sv": "Bahrain",
    "nom_da": "Bahrain",
    "nom_no": "Bahrain",
    "nom_fi": "Bahrain"
  },
  "bangladesh": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bangladesh/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bangladesh/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bangladesh/flag.png",
    "nom_fr": "Bangladesh",
    "nom_en": "Bangladesh",
    "nom_de": "Bangladesch",
    "nom_es": "Bangladés",
    "nom_pt": "Bangladesh",
    "nom_it": "Bangladesh",
    "nom_nl": "Bangladesh",
    "nom_sv": "Bangladesh",
    "nom_da": "Bangladesh",
    "nom_no": "Bangladesh",
    "nom_fi": "Bangladesh"
  },
  "barbados": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/barbados/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/barbados/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/barbados/flag.png",
    "nom_fr": "Barbade",
    "nom_en": "Barbados",
    "nom_de": "Barbados",
    "nom_es": "Barbados",
    "nom_pt": "Barbados",
    "nom_it": "Barbados",
    "nom_nl": "Barbados",
    "nom_sv": "Barbados",
    "nom_da": "Barbados",
    "nom_no": "Barbados",
    "nom_fi": "Barbados"
  },
  "belarus": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belarus/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belarus/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belarus/flag.png",
    "nom_fr": "Biélorussie",
    "nom_en": "Belarus",
    "nom_de": "Belarus",
    "nom_es": "Bielorrusia",
    "nom_pt": "Bielorrússia",
    "nom_it": "Bielorussia",
    "nom_nl": "Wit-Rusland",
    "nom_sv": "Vitryssland",
    "nom_da": "Hviderusland",
    "nom_no": "Hviterussland",
    "nom_fi": "Valko-Venäjä"
  },
  "belgium": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belgium/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belgium/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belgium/flag.png",
    "nom_fr": "Belgique",
    "nom_en": "Belgium",
    "nom_de": "Belgien",
    "nom_es": "Bélgica",
    "nom_pt": "Bélgica",
    "nom_it": "Belgio",
    "nom_nl": "België",
    "nom_sv": "Belgien",
    "nom_da": "Belgien",
    "nom_no": "Belgia",
    "nom_fi": "Belgia"
  },
  "belize": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belize/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belize/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/belize/flag.png",
    "nom_fr": "Belize",
    "nom_en": "Belize",
    "nom_de": "Belize",
    "nom_es": "Belice",
    "nom_pt": "Belize",
    "nom_it": "Belize",
    "nom_nl": "Belize",
    "nom_sv": "Belize",
    "nom_da": "Belize",
    "nom_no": "Belize",
    "nom_fi": "Belize"
  },
  "benin": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/benin/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/benin/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/benin/flag.png",
    "nom_fr": "Bénin",
    "nom_en": "Benin",
    "nom_de": "Benin",
    "nom_es": "Benín",
    "nom_pt": "Benim",
    "nom_it": "Benin",
    "nom_nl": "Benin",
    "nom_sv": "Benin",
    "nom_da": "Benin",
    "nom_no": "Benin",
    "nom_fi": "Benin"
  },
  "bermuda": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bermuda/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bermuda/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bermuda/flag.png",
    "nom_fr": "Bermudes",
    "nom_en": "Bermuda",
    "nom_de": "Bermuda",
    "nom_es": "Bermudas",
    "nom_pt": "Bermudas",
    "nom_it": "Bermuda",
    "nom_nl": "Bermuda",
    "nom_sv": "Bermuda",
    "nom_da": "Bermuda",
    "nom_no": "Bermuda",
    "nom_fi": "Bermuda"
  },
  "bhutan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bhutan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bhutan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bhutan/flag.png",
    "nom_fr": "Bhoutan",
    "nom_en": "Bhutan",
    "nom_de": "Bhutan",
    "nom_es": "Bután",
    "nom_pt": "Butão",
    "nom_it": "Bhutan",
    "nom_nl": "Bhutan",
    "nom_sv": "Bhutan",
    "nom_da": "Bhutan",
    "nom_no": "Bhutan",
    "nom_fi": "Bhutan"
  },
  "bolivia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bolivia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bolivia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bolivia/flag.png",
    "nom_fr": "Bolivie",
    "nom_en": "Bolivia",
    "nom_de": "Bolivien",
    "nom_es": "Bolivia",
    "nom_pt": "Bolívia",
    "nom_it": "Bolivia",
    "nom_nl": "Bolivia",
    "nom_sv": "Bolivia",
    "nom_da": "Bolivia",
    "nom_no": "Bolivia",
    "nom_fi": "Bolivia"
  },
  "bosnia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bosnia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bosnia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bosnia/flag.png",
    "nom_fr": "Bosnie-Herzégovine",
    "nom_en": "Bosnia and Herzegovina",
    "nom_de": "Bosnien und Herzegowina",
    "nom_es": "Bosnia y Herzegovina",
    "nom_pt": "Bósnia e Herzegovina",
    "nom_it": "Bosnia ed Erzegovina",
    "nom_nl": "Bosnië ed Herzegovina",
    "nom_sv": "Bosnien och Hercegovina",
    "nom_da": "Bosnien-Hercegovina",
    "nom_no": "Bosnia-Hercegovina",
    "nom_fi": "Bosnia ja Hertsegovina"
  },
  "botswana": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/botswana/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/botswana/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/botswana/flag.png",
    "nom_fr": "Botswana",
    "nom_en": "Botswana",
    "nom_de": "Botswana",
    "nom_es": "Botsuana",
    "nom_pt": "Botsuana",
    "nom_it": "Botswana",
    "nom_nl": "Botswana",
    "nom_sv": "Botswana",
    "nom_da": "Botswana",
    "nom_no": "Botswana",
    "nom_fi": "Botswana"
  },
  "brazil": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/brazil/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/brazil/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/brazil/flag.png",
    "nom_fr": "Brésil",
    "nom_en": "Brazil",
    "nom_de": "Brasilien",
    "nom_es": "Brasil",
    "nom_pt": "Brasil",
    "nom_it": "Brasile",
    "nom_nl": "Brazilië",
    "nom_sv": "Brasilien",
    "nom_da": "Brasilien",
    "nom_no": "Brasil",
    "nom_fi": "Brasilia"
  },
  "bretagne": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bretagne/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bretagne/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bretagne/flag.png",
    "nom_fr": "Bretagne",
    "nom_en": "Brittany",
    "nom_de": "Bretagne",
    "nom_es": "Bretaña",
    "nom_pt": "Bretanha",
    "nom_it": "Bretagna",
    "nom_nl": "Bretagne",
    "nom_sv": "Bretagne",
    "nom_da": "Bretagne",
    "nom_no": "Bretagne",
    "nom_fi": "Bretagne"
  },
  "brunei": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/brunei/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/brunei/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/brunei/flag.png",
    "nom_fr": "Brunei",
    "nom_en": "Brunei",
    "nom_de": "Brunei",
    "nom_es": "Brunéi",
    "nom_pt": "Brunei",
    "nom_it": "Brunei",
    "nom_nl": "Brunei",
    "nom_sv": "Brunei",
    "nom_da": "Brunei",
    "nom_no": "Brunei",
    "nom_fi": "Brunei"
  },
  "bulgaria": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bulgaria/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bulgaria/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/bulgaria/flag.png",
    "nom_fr": "Bulgarie",
    "nom_en": "Bulgaria",
    "nom_de": "Bulgarien",
    "nom_es": "Bulgaria",
    "nom_pt": "Bulgária",
    "nom_it": "Bulgaria",
    "nom_nl": "Bulgarije",
    "nom_sv": "Bulgarien",
    "nom_da": "Bulgarien",
    "nom_no": "Bulgaria",
    "nom_fi": "Bulgaria"
  },
  "burkina-faso": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/burkina-faso/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/burkina-faso/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/burkina-faso/flag.png",
    "nom_fr": "Burkina Faso",
    "nom_en": "Burkina Faso",
    "nom_de": "Burkina Faso",
    "nom_es": "Burkina Faso",
    "nom_pt": "Burquina Faso",
    "nom_it": "Burkina Faso",
    "nom_nl": "Burkina Faso",
    "nom_sv": "Burkina Faso",
    "nom_da": "Burkina Faso",
    "nom_no": "Burkina Faso",
    "nom_fi": "Burkina Faso"
  },
  "burundi": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/burundi/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/burundi/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/burundi/flag.png",
    "nom_fr": "Burundi",
    "nom_en": "Burundi",
    "nom_de": "Burundi",
    "nom_es": "Burundi",
    "nom_pt": "Burundi",
    "nom_it": "Burundi",
    "nom_nl": "Burundi",
    "nom_sv": "Burundi",
    "nom_da": "Burundi",
    "nom_no": "Burundi",
    "nom_fi": "Burundi"
  },
  "cambodia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cambodia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cambodia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cambodia/flag.png",
    "nom_fr": "Cambodge",
    "nom_en": "Cambodia",
    "nom_de": "Kambodscha",
    "nom_es": "Camboya",
    "nom_pt": "Camboja",
    "nom_it": "Cambogia",
    "nom_nl": "Cambodja",
    "nom_sv": "Kambodja",
    "nom_da": "Cambodja",
    "nom_no": "Kambodsja",
    "nom_fi": "Kambodža"
  },
  "cameroon": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cameroon/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cameroon/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cameroon/flag.png",
    "nom_fr": "Cameroun",
    "nom_en": "Cameroon",
    "nom_de": "Kamerun",
    "nom_es": "Camerún",
    "nom_pt": "Camarões",
    "nom_it": "Camerun",
    "nom_nl": "Kameroen",
    "nom_sv": "Kamerun",
    "nom_da": "Cameroun",
    "nom_no": "Kamerun",
    "nom_fi": "Kamerun"
  },
  "canada": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/canada2/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/canada2/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/canada2/flag.png",
    "nom_fr": "Canada",
    "nom_en": "Canada",
    "nom_de": "Kanada",
    "nom_es": "Canadá",
    "nom_pt": "Canadá",
    "nom_it": "Canada",
    "nom_nl": "Canada",
    "nom_sv": "Canada",
    "nom_da": "Canada",
    "nom_no": "Canada",
    "fi": "Kanada"
  },
  "cape-verde": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cape-verde/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cape-verde/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cape-verde/flag.png",
    "nom_fr": "Cap-Vert",
    "nom_en": "Cape Verde",
    "nom_de": "Kap Verde",
    "nom_es": "Cabo Verde",
    "nom_pt": "Cabo Verde",
    "nom_it": "Capo Verde",
    "nom_nl": "Kaapverdië",
    "nom_sv": "Kap Verde",
    "nom_da": "Kap Verde",
    "nom_no": "Kapp Verde",
    "nom_fi": "Kap Verde"
  },
  "central-african-republic": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/central-african-republic/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/central-african-republic/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/central-african-republic/flag.png",
    "nom_fr": "République centrafricaine",
    "nom_en": "Central African Republic",
    "nom_de": "Zentralafrikanische Republik",
    "nom_es": "República Centroafricana",
    "nom_pt": "República Centro-Africana",
    "nom_it": "Repubblica Centrafricana",
    "nom_nl": "Centraal-Afrikaanse Republiek",
    "nom_sv": "Centralafrikanska republiken",
    "nom_da": "Centralafrikanske Republik",
    "nom_no": "Den sentralafrikanske republikk",
    "nom_fi": "Keski-Afrikan tasavalta"
  },
  "chad": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chad/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chad/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chad/flag.png",
    "nom_fr": "Tchad",
    "nom_en": "Chad",
    "nom_de": "Tschad",
    "nom_es": "Chad",
    "nom_pt": "Chade",
    "nom_it": "Ciad",
    "nom_nl": "Tsjaad",
    "nom_sv": "Tchad",
    "nom_da": "Tchad",
    "nom_no": "Tsjad",
    "nom_fi": "Tšad"
  },
  "chaoui": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chaoui/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chaoui/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chaoui/flag.png",
    "nom_fr": "Chaoui",
    "nom_en": "Shawiya",
    "nom_de": "Shawiya",
    "nom_es": "Chaoui",
    "nom_pt": "Chaoui",
    "nom_it": "Chaoui",
    "nom_nl": "Chaoui",
    "nom_sv": "Chaoui",
    "nom_da": "Chaoui",
    "nom_no": "Chaoui",
    "nom_fi": "Chaoui"
  },
  "chechnya": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chechnya/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chechnya/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chechnya/flag.png",
    "nom_fr": "Tchétchénie",
    "nom_en": "Chechnya",
    "nom_de": "Tschetschenien",
    "nom_es": "Chechenia",
    "nom_pt": "Chechénia",
    "nom_it": "Cecenia",
    "nom_nl": "Tsjetsjenië",
    "nom_sv": "Tjetjenien",
    "nom_da": "Tjetjenien",
    "nom_no": "Tsjetsjenia",
    "nom_fi": "Tšetšenia"
  },
  "chile": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chile/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chile/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chile/flag.png",
    "nom_fr": "Chili",
    "nom_en": "Chile",
    "nom_de": "Chile",
    "nom_es": "Chile",
    "nom_pt": "Chile",
    "nom_it": "Cile",
    "nom_nl": "Chili",
    "nom_sv": "Chile",
    "nom_da": "Chile",
    "nom_no": "Chile",
    "nom_fi": "Chile"
  },
  "china": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/china/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/china/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/china/flag.png",
    "nom_fr": "Chine",
    "nom_en": "China",
    "nom_de": "China",
    "nom_es": "China",
    "nom_pt": "China",
    "nom_it": "Cina",
    "nom_nl": "China",
    "nom_sv": "Kina",
    "nom_da": "Kina",
    "nom_no": "Kina",
    "nom_fi": "Kiina"
  },
  "chleuh": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chleuh/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chleuh/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/chleuh/flag.png",
    "nom_fr": "Chleuh",
    "nom_en": "Shilha",
    "nom_de": "Shilha",
    "nom_es": "Chleuh",
    "nom_pt": "Chleuh",
    "nom_it": "Chleuh",
    "nom_nl": "Chleuh",
    "nom_sv": "Chleuh",
    "nom_da": "Chleuh",
    "nom_no": "Chleuh",
    "nom_fi": "Chleuh"
  },
  "colombia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/colombia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/colombia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/colombia/flag.png",
    "nom_fr": "Colombie",
    "nom_en": "Colombia",
    "nom_de": "Kolumbien",
    "nom_es": "Colombia",
    "nom_pt": "Colômbia",
    "nom_it": "Colombia",
    "nom_nl": "Colombia",
    "nom_sv": "Colombia",
    "nom_da": "Colombia",
    "nom_no": "Colombia",
    "nom_fi": "Kolumbia"
  },
  "comoros": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/comoros/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/comoros/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/comoros/flag.png",
    "nom_fr": "Comores",
    "nom_en": "Comoros",
    "nom_de": "Komoren",
    "nom_es": "Comoras",
    "nom_pt": "Comores",
    "nom_it": "Comore",
    "nom_nl": "Comoren",
    "nom_sv": "Komorerna",
    "nom_da": "Comorerne",
    "nom_no": "Komorene",
    "nom_fi": "Komorit"
  },
  "corse": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/corse/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/corse/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/corse/flag.png",
    "nom_fr": "Corse",
    "nom_en": "Corsica",
    "nom_de": "Korsika",
    "nom_es": "Córcega",
    "nom_pt": "Córsega",
    "nom_it": "Corsica",
    "nom_nl": "Corsica",
    "nom_sv": "Korsika",
    "nom_da": "Korsika",
    "nom_no": "Korsika",
    "nom_fi": "Korsika"
  },
  "costa-rica": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/costa-rica/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/costa-rica/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/costa-rica/flag.png",
    "nom_fr": "Costa Rica",
    "nom_en": "Costa Rica",
    "nom_de": "Costa Rica",
    "nom_es": "Costa Rica",
    "nom_pt": "Costa Rica",
    "nom_it": "Costa Rica",
    "nom_nl": "Costa Rica",
    "nom_sv": "Costa Rica",
    "nom_da": "Costa Rica",
    "nom_no": "Costa Rica",
    "nom_fi": "Costa Rica"
  },
  "croatia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/croatia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/croatia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/croatia/flag.png",
    "nom_fr": "Croatie",
    "nom_en": "Croatia",
    "nom_de": "Kroatien",
    "nom_es": "Croacia",
    "nom_pt": "Croácia",
    "nom_it": "Croazia",
    "nom_nl": "Kroatië",
    "nom_sv": "Kroatien",
    "nom_da": "Kroatien",
    "nom_no": "Kroatia",
    "nom_fi": "Kroatia"
  },
  "cuba": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cuba/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cuba/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cuba/flag.png",
    "nom_fr": "Cuba",
    "nom_en": "Cuba",
    "nom_de": "Kuba",
    "nom_es": "Cuba",
    "nom_pt": "Cuba",
    "nom_it": "Cuba",
    "nom_nl": "Cuba",
    "nom_sv": "Cuba",
    "nom_da": "Cuba",
    "nom_no": "Cuba",
    "nom_fi": "Kuuba"
  },
  "cyprus": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cyprus/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cyprus/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/cyprus/flag.png",
    "nom_fr": "Chypre",
    "nom_en": "Cyprus",
    "nom_de": "Zypern",
    "nom_es": "Chipre",
    "nom_pt": "Chipre",
    "nom_it": "Cipro",
    "nom_nl": "Cyprus",
    "nom_sv": "Cypern",
    "nom_da": "Cypern",
    "nom_no": "Kypros",
    "nom_fi": "Kypros"
  },
  "czech-republic": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/czech-republic/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/czech-republic/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/czech-republic/flag.png",
    "nom_fr": "République tchèque",
    "nom_en": "Czech Republic",
    "nom_de": "Tschechien",
    "nom_es": "República Checa",
    "nom_pt": "República Checa",
    "nom_it": "Repubblica Ceca",
    "nom_nl": "Tsjechië",
    "nom_sv": "Tjeckien",
    "nom_da": "Tjekkiet",
    "nom_no": "Tsjekkia",
    "nom_fi": "Tšekki"
  },
  "dagestan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/dagestan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/dagestan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/dagestan/flag.png",
    "nom_fr": "Daghestan",
    "nom_en": "Dagestan",
    "nom_de": "Dagestan",
    "nom_es": "Daguestán",
    "nom_pt": "Daguestão",
    "nom_it": "Daghestan",
    "nom_nl": "Dagestan",
    "nom_sv": "Dagestan",
    "nom_da": "Dagestan",
    "nom_no": "Dagestan",
    "nom_fi": "Dagestan"
  },
  "democratic-republic-of-the-congo": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/democratic-republic-of-the-congo/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/democratic-republic-of-the-congo/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/democratic-republic-of-the-congo/flag.png",
    "nom_fr": "République démocratique du Congo",
    "nom_en": "Democratic Republic of the Congo",
    "nom_de": "Demokratische Republik Kongo",
    "nom_es": "República Democrática del Congo",
    "nom_pt": "República Democrática do Congo",
    "nom_it": "Repubblica Democratica del Congo",
    "nom_nl": "Democratische Republiek Congo",
    "nom_sv": "Demokratiska republiken Kongo",
    "nom_da": "Demokratiske Republik Congo",
    "nom_no": "Den demokratiske republikken Kongo",
    "nom_fi": "Kongon demokraattinen tasavalta"
  },
  "denmark": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/denmark/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/denmark/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/denmark/flag.png",
    "nom_fr": "Danemark",
    "nom_en": "Denmark",
    "nom_de": "Dänemark",
    "nom_es": "Dinamarca",
    "nom_pt": "Dinamarca",
    "nom_it": "Danimarca",
    "nom_nl": "Denemarken",
    "nom_sv": "Danmark",
    "nom_da": "Danmark",
    "nom_no": "Danmark",
    "nom_fi": "Tanska"
  },
  "djibouti": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/djibouti/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/djibouti/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/djibouti/flag.png",
    "nom_fr": "Djibouti",
    "nom_en": "Djibouti",
    "nom_de": "Dschibuti",
    "nom_es": "Yibuti",
    "nom_pt": "Djibouti",
    "nom_it": "Gibuti",
    "nom_nl": "Djibouti",
    "nom_sv": "Djibouti",
    "nom_da": "Djibouti",
    "nom_no": "Djibouti",
    "nom_fi": "Djibouti"
  },
  "dominican-republic": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/dominican-republic/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/dominican-republic/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/dominican-republic/flag.png",
    "nom_fr": "République dominicaine",
    "nom_en": "Dominican Republic",
    "nom_de": "Dominikanische Republik",
    "nom_es": "República Dominicana",
    "nom_pt": "República Dominicana",
    "nom_it": "Repubblica Dominicana",
    "nom_nl": "Dominicaanse Republiek",
    "nom_sv": "Dominikanska republiken",
    "nom_da": "Dominikanske Republik",
    "nom_no": "Den dominikanske republikk",
    "nom_fi": "Dominikaaninen tasavalta"
  },
  "east-timor": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/east-timor/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/east-timor/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/east-timor/flag.png",
    "nom_fr": "Timor oriental",
    "nom_en": "East Timor",
    "nom_de": "Osttimor",
    "nom_es": "Timor Oriental",
    "nom_pt": "Timor-Leste",
    "nom_it": "Timor Est",
    "nom_nl": "Oost-Timor",
    "nom_sv": "Östtimor",
    "nom_da": "Østtimor",
    "nom_no": "Øst-Timor",
    "nom_fi": "Itä-Timor"
  },
  "ecuador": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ecuador/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ecuador/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ecuador/flag.png",
    "nom_fr": "Équateur",
    "nom_en": "Ecuador",
    "nom_de": "Ecuador",
    "nom_es": "Ecuador",
    "nom_pt": "Equador",
    "nom_it": "Ecuador",
    "nom_nl": "Ecuador",
    "nom_sv": "Ecuador",
    "nom_da": "Ecuador",
    "nom_no": "Ecuador",
    "nom_fi": "Ecuador"
  },
  "egypt": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/egypt/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/egypt/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/egypt/flag.png",
    "nom_fr": "Égypte",
    "nom_en": "Egypt",
    "nom_de": "Ägypten",
    "nom_es": "Egipto",
    "nom_pt": "Egito",
    "nom_it": "Egitto",
    "nom_nl": "Egypte",
    "nom_sv": "Egypten",
    "nom_da": "Egypten",
    "nom_no": "Egypt",
    "nom_fi": "Egypti"
  },
  "el-salvador": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/el-salvador/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/el-salvador/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/el-salvador/flag.png",
    "nom_fr": "Salvador",
    "nom_en": "El Salvador",
    "nom_de": "El Salvador",
    "nom_es": "El Salvador",
    "nom_pt": "El Salvador",
    "nom_it": "El Salvador",
    "nom_nl": "El Salvador",
    "nom_sv": "El Salvador",
    "nom_da": "El Salvador",
    "nom_no": "El Salvador",
    "nom_fi": "El Salvador"
  },
  "england": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/england/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/england/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/england/flag.png",
    "nom_fr": "Angleterre",
    "nom_en": "England",
    "nom_de": "England",
    "nom_es": "Inglaterra",
    "nom_pt": "Inglaterra",
    "nom_it": "Inghilterra",
    "nom_nl": "Engeland",
    "nom_sv": "England",
    "nom_da": "England",
    "nom_no": "England",
    "nom_fi": "Englanti"
  },
  "eritrea": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/eritrea/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/eritrea/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/eritrea/flag.png",
    "nom_fr": "Érythrée",
    "nom_en": "Eritrea",
    "nom_de": "Eritrea",
    "nom_es": "Eritrea",
    "nom_pt": "Eritreia",
    "nom_it": "Eritrea",
    "nom_nl": "Eritrea",
    "nom_sv": "Eritrea",
    "nom_da": "Eritrea",
    "nom_no": "Eritrea",
    "nom_fi": "Eritrea"
  },
  "estonia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/estonia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/estonia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/estonia/flag.png",
    "nom_fr": "Estonie",
    "nom_en": "Estonia",
    "nom_de": "Estland",
    "nom_es": "Estonia",
    "nom_pt": "Estónia",
    "nom_it": "Estonia",
    "nom_nl": "Estland",
    "nom_sv": "Estland",
    "nom_da": "Estland",
    "nom_no": "Estland",
    "nom_fi": "Viro"
  },
  "eswatini": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/eswatini/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/eswatini/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/eswatini/flag.png",
    "nom_fr": "Eswatini",
    "nom_en": "Eswatini",
    "nom_de": "Eswatini",
    "nom_es": "Eswatini",
    "nom_pt": "Eswatini",
    "nom_it": "Eswatini",
    "nom_nl": "Eswatini",
    "nom_sv": "Eswatini",
    "nom_da": "Eswatini",
    "nom_no": "Eswatini",
    "nom_fi": "Eswatini"
  },
  "ethiopia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ethiopia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ethiopia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ethiopia/flag.png",
    "nom_fr": "Éthiopie",
    "nom_en": "Ethiopia",
    "nom_de": "Äthiopien",
    "nom_es": "Etiopía",
    "nom_pt": "Etiópia",
    "nom_it": "Etiopia",
    "nom_nl": "Ethiopië",
    "nom_sv": "Etiopien",
    "nom_da": "Etiopien",
    "nom_no": "Etiopia",
    "nom_fi": "Etiopia"
  },
  "finland": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/finland/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/finland/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/finland/flag.png",
    "nom_fr": "Finlande",
    "nom_en": "Finland",
    "nom_de": "Finnland",
    "nom_es": "Finlandia",
    "nom_pt": "Finlândia",
    "nom_it": "Finlandia",
    "nom_nl": "Finland",
    "nom_sv": "Finland",
    "nom_da": "Finland",
    "nom_no": "Finland",
    "nom_fi": "Suomi"
  },
  "france": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/france/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/france/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/france/flag.png",
    "nom_fr": "France",
    "nom_en": "France",
    "nom_de": "Frankreich",
    "nom_es": "Francia",
    "nom_pt": "França",
    "nom_it": "Francia",
    "nom_nl": "Frankrijk",
    "nom_sv": "Frankrike",
    "nom_da": "Frankrig",
    "nom_no": "Frankrike",
    "nom_fi": "Ranska"
  },
  "gabon": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gabon/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gabon/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gabon/flag.png",
    "nom_fr": "Gabon",
    "nom_en": "Gabon",
    "nom_de": "Gabun",
    "nom_es": "Gabón",
    "nom_pt": "Gabão",
    "nom_it": "Gabon",
    "nom_nl": "Gabon",
    "nom_sv": "Gabon",
    "nom_da": "Gabon",
    "nom_no": "Gabon",
    "nom_fi": "Gabon"
  },
  "gambia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gambia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gambia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gambia/flag.png",
    "nom_fr": "Gambie",
    "nom_en": "Gambia",
    "nom_de": "Gambia",
    "nom_es": "Gambia",
    "nom_pt": "Gâmbia",
    "nom_it": "Gambia",
    "nom_nl": "Gambia",
    "nom_sv": "Gambia",
    "nom_da": "Gambia",
    "nom_no": "Gambia",
    "nom_fi": "Gambia"
  },
  "georgia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/georgia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/georgia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/georgia/flag.png",
    "nom_fr": "Géorgie",
    "nom_en": "Georgia",
    "nom_de": "Georgien",
    "nom_es": "Georgia",
    "nom_pt": "Geórgia",
    "nom_it": "Georgia",
    "nom_nl": "Georgië",
    "nom_sv": "Georgien",
    "nom_da": "Georgien",
    "nom_no": "Georgia",
    "nom_fi": "Georgia"
  },
  "germany": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/germany/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/germany/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/germany/flag.png",
    "nom_fr": "Allemagne",
    "nom_en": "Germany",
    "nom_de": "Deutschland",
    "nom_es": "Alemania",
    "nom_pt": "Alemanha",
    "nom_it": "Germania",
    "nom_nl": "Duitsland",
    "nom_sv": "Tyskland",
    "nom_da": "Tyskland",
    "nom_no": "Tyskland",
    "nom_fi": "Saksa"
  },
  "ghana": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ghana/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ghana/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ghana/flag.png",
    "nom_fr": "Ghana",
    "nom_en": "Ghana",
    "nom_de": "Ghana",
    "nom_es": "Ghana",
    "nom_pt": "Gana",
    "nom_it": "Ghana",
    "nom_nl": "Ghana",
    "nom_sv": "Ghana",
    "nom_da": "Ghana",
    "nom_no": "Ghana",
    "nom_fi": "Ghana"
  },
  "gibraltar": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gibraltar/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gibraltar/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gibraltar/flag.png",
    "nom_fr": "Gibraltar",
    "nom_en": "Gibraltar",
    "nom_de": "Gibraltar",
    "nom_es": "Gibraltar",
    "nom_pt": "Gibraltar",
    "nom_it": "Gibilterra",
    "nom_nl": "Gibraltar",
    "nom_sv": "Gibraltar",
    "nom_da": "Gibraltar",
    "nom_no": "Gibraltar",
    "nom_fi": "Gibraltar"
  },
  "greece": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/greece/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/greece/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/greece/flag.png",
    "nom_fr": "Grèce",
    "nom_en": "Greece",
    "nom_de": "Griechenland",
    "nom_es": "Grecia",
    "nom_pt": "Grécia",
    "nom_it": "Grecia",
    "nom_nl": "Griekenland",
    "nom_sv": "Grekland",
    "nom_da": "Grækenland",
    "nom_no": "Hellas",
    "nom_fi": "Kreikka"
  },
  "grenada": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/grenada/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/grenada/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/grenada/flag.png",
    "nom_fr": "Grenade",
    "nom_en": "Grenada",
    "nom_de": "Grenada",
    "nom_es": "Granada",
    "nom_pt": "Granada",
    "nom_it": "Grenada",
    "nom_nl": "Grenada",
    "nom_sv": "Grenada",
    "nom_da": "Grenada",
    "nom_no": "Grenada",
    "nom_fi": "Grenada"
  },
  "guadeloupe": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guadeloupe/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guadeloupe/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guadeloupe/flag.png",
    "nom_fr": "Guadeloupe",
    "nom_en": "Guadeloupe",
    "nom_de": "Guadeloupe",
    "nom_es": "Guadalupe",
    "nom_pt": "Guadalupe",
    "nom_it": "Guadalupa",
    "nom_nl": "Guadeloupe",
    "nom_sv": "Guadeloupe",
    "nom_da": "Guadeloupe",
    "nom_no": "Guadeloupe",
    "nom_fi": "Guadeloupe"
  },
  "guam": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guam/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guam/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guam/flag.png",
    "nom_fr": "Guam",
    "nom_en": "Guam",
    "nom_de": "Guam",
    "nom_es": "Guam",
    "nom_pt": "Guam",
    "nom_it": "Guam",
    "nom_nl": "Guam",
    "nom_sv": "Guam",
    "nom_da": "Guam",
    "nom_no": "Guam",
    "nom_fi": "Guam"
  },
  "guatemala": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guatemala/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guatemala/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guatemala/flag.png",
    "nom_fr": "Guatemala",
    "nom_en": "Guatemala",
    "nom_de": "Guatemala",
    "nom_es": "Guatemala",
    "nom_pt": "Guatemala",
    "nom_it": "Guatemala",
    "nom_nl": "Guatemala",
    "nom_sv": "Guatemala",
    "nom_da": "Guatemala",
    "nom_no": "Guatemala",
    "nom_fi": "Guatemala"
  },
  "guineaa": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guineaa/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guineaa/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guineaa/flag.png",
    "nom_fr": "Guinée",
    "nom_en": "Guinea",
    "nom_de": "Guinea",
    "nom_es": "Guinea",
    "nom_pt": "Guiné",
    "nom_it": "Guinea",
    "nom_nl": "Guinee",
    "nom_sv": "Guinea",
    "nom_da": "Guinea",
    "nom_no": "Guinea",
    "nom_fi": "Guinea"
  },
  "guinea-bissau": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guinea-bissau/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guinea-bissau/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guinea-bissau/flag.png",
    "nom_fr": "Guinée-Bissau",
    "nom_en": "Guinea-Bissau",
    "nom_de": "Guinea-Bissau",
    "nom_es": "Guinea-Bisáu",
    "nom_pt": "Guiné-Bissau",
    "nom_it": "Guinea-Bissau",
    "nom_nl": "Guinee-Bissau",
    "nom_sv": "Guinea-Bissau",
    "nom_da": "Guinea-Bissau",
    "nom_no": "Guinea-Bissau",
    "nom_fi": "Guinea-Bissau"
  },
  "guyana": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guyana/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guyana/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guyana/flag.png",
    "nom_fr": "Guyana",
    "nom_en": "Guyana",
    "nom_de": "Guyana",
    "nom_es": "Guyana",
    "nom_pt": "Guayana",
    "nom_it": "Guyana",
    "nom_nl": "Guyana",
    "nom_sv": "Guyana",
    "nom_da": "Guyana",
    "nom_no": "Guyana",
    "nom_fi": "Guyana"
  },
  "guyane française": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guyane/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guyane/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/guyane/flag.png",
    "nom_fr": "Guyane Française",
    "nom_en": "French Guiana",
    "nom_de": "Französisch-Guayana",
    "nom_es": "Guayana Francesa",
    "nom_pt": "Guiana Francesa",
    "nom_it": "Guyana Francese",
    "nom_nl": "Frans-Guyana",
    "nom_sv": "Franska Guyana",
    "nom_da": "Fransk Guyana",
    "nom_no": "Fransk Guyana",
    "nom_fi": "Ranskan Guayana"
  },
  "gypsy": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gypsy/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gypsy/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/gypsy/flag.png",
    "nom_fr": "Communauté du voyage",
    "nom_en": "Romani / Romani Travelers",
    "nom_de": "Sinti und Roma / Fahrende",
    "nom_es": "Gitanos / Romani",
    "nom_pt": "Ciganos / Romani",
    "nom_it": "Rom / Sinti",
    "nom_nl": "Roma / Sinti",
    "nom_sv": "Romer / Resande",
    "nom_da": "Romaer / Rejsende",
    "nom_no": "Romer / Reisende",
    "nom_fi": "Romanit / Kiertolaiset"
  },
  "haiti": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/haiti/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/haiti/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/haiti/flag.png",
    "nom_fr": "Haïti",
    "nom_en": "Haiti",
    "nom_de": "Haiti",
    "nom_es": "Haití",
    "nom_pt": "Haiti",
    "nom_it": "Haiti",
    "nom_nl": "Haïti",
    "nom_sv": "Haiti",
    "nom_da": "Haiti",
    "nom_no": "Haiti",
    "nom_fi": "Haiti"
  },
  "honduras": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/honduras/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/honduras/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/honduras/flag.png",
    "nom_fr": "Honduras",
    "nom_en": "Honduras",
    "nom_de": "Honduras",
    "nom_es": "Honduras",
    "nom_pt": "Honduras",
    "nom_it": "Honduras",
    "nom_nl": "Honduras",
    "nom_sv": "Honduras",
    "nom_da": "Honduras",
    "nom_no": "Honduras",
    "nom_fi": "Honduras"
  },
  "custom_product": {},
  "hungary": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/hungary/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/hungary/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/hungary/flag.png",
    "nom_fr": "Hongrie",
    "nom_en": "Hungary",
    "nom_de": "Ungarn",
    "nom_es": "Hungría",
    "nom_pt": "Hungria",
    "nom_it": "Ungheria",
    "nom_nl": "Hongarije",
    "nom_sv": "Ungern",
    "nom_da": "Ungarn",
    "nom_no": "Ungarn",
    "nom_fi": "Unkari"
  },
  "iceland": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iceland/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iceland/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iceland/flag.png",
    "nom_fr": "Islande",
    "nom_en": "Iceland",
    "nom_de": "Island",
    "nom_es": "Islandia",
    "nom_pt": "Islândia",
    "nom_it": "Islanda",
    "nom_nl": "IJsland",
    "nom_sv": "Island",
    "nom_da": "Island",
    "nom_no": "Island",
    "nom_fi": "Islanti"
  },
  "india": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/india/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/india/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/india/flag.png",
    "nom_fr": "Inde",
    "nom_en": "India",
    "nom_de": "Indien",
    "nom_es": "India",
    "nom_pt": "Índia",
    "nom_it": "India",
    "nom_nl": "India",
    "nom_sv": "Indien",
    "nom_da": "Indien",
    "nom_no": "India",
    "nom_fi": "Intia"
  },
  "indonesia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/indonesia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/indonesia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/indonesia/flag.png",
    "nom_fr": "Indonésie",
    "nom_en": "Indonesia",
    "nom_de": "Indonesien",
    "nom_es": "Indonesia",
    "nom_pt": "Indonésia",
    "nom_it": "Indonesia",
    "nom_nl": "Indonesië",
    "nom_sv": "Indonesien",
    "nom_da": "Indonesien",
    "nom_no": "Indonesia",
    "nom_fi": "Indonesia"
  },
  "iran": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iran/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iran/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iran/flag.png",
    "nom_fr": "Iran",
    "nom_en": "Iran",
    "nom_de": "Iran",
    "nom_es": "Irán",
    "nom_pt": "Irão",
    "nom_it": "Iran",
    "nom_nl": "Iran",
    "nom_sv": "Iran",
    "nom_da": "Iran",
    "nom_no": "Iran",
    "nom_fi": "Iran"
  },
  "iran_lion": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iran/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iran/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iran/IRAN.png",
    "nom_fr": "Iran - Lion et Soleil",
    "nom_en": "Iran - Lion and Sun",
    "nom_de": "Iran - Löwe und Sonne",
    "nom_es": "Irán - León y Sol",
    "nom_pt": "Irão - Leão e Sol",
    "nom_it": "Iran - Leone e Sole",
    "nom_nl": "Iran - Leeuw en Zon",
    "nom_sv": "Iran - Lejon och Sol",
    "nom_da": "Iran - Løve og Sol",
    "nom_no": "Iran - Løve og Sol",
    "nom_fi": "Iran - Leijona ja Aurinko"
  },
  "iraq": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iraq/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iraq/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/iraq/flag.png",
    "nom_fr": "Irak",
    "nom_en": "Iraq",
    "nom_de": "Irak",
    "nom_es": "Irak",
    "nom_pt": "Iraque",
    "nom_it": "Iraq",
    "nom_nl": "Irak",
    "nom_sv": "Irak",
    "nom_da": "Irak",
    "nom_no": "Irak",
    "nom_fi": "Irak"
  },
  "ireland": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ireland/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ireland/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ireland/flag.png",
    "nom_fr": "Irlande",
    "nom_en": "Ireland",
    "nom_de": "Irland",
    "nom_es": "Irlanda",
    "nom_pt": "Irlanda",
    "nom_it": "Irlanda",
    "nom_nl": "Ierland",
    "nom_sv": "Irland",
    "nom_da": "Irland",
    "nom_no": "Irland",
    "nom_fi": "Irlanti"
  },
  "italy": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/italy/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/italy/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/italy/flag.png",
    "nom_fr": "Italie",
    "nom_en": "Italy",
    "nom_de": "Italien",
    "nom_es": "Italia",
    "nom_pt": "Itália",
    "nom_it": "Italia",
    "nom_nl": "Italië",
    "nom_sv": "Italien",
    "nom_da": "Italien",
    "nom_no": "Italia",
    "nom_fi": "Italia"
  },
  "ivory-coast": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ivory-coast/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ivory-coast/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ivory-coast/flag.png",
    "nom_fr": "Côte d’Ivoire",
    "nom_en": "Ivory Coast",
    "nom_de": "Elfenbeinküste",
    "nom_es": "Costa de Marfil",
    "nom_pt": "Costa do Marfim",
    "nom_it": "Costa d'Avorio",
    "nom_nl": "Ivoorkust",
    "nom_sv": "Elfenbenskusten",
    "nom_da": "Elfenbenskysten",
    "nom_no": "Elfenbenskysten",
    "nom_fi": "Norsunluurannikko"
  },
  "jamaica": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/jamaica/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/jamaica/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/jamaica/flag.png",
    "nom_fr": "Jamaïque",
    "nom_en": "Jamaica",
    "nom_de": "Jamaika",
    "nom_es": "Jamaica",
    "nom_pt": "Jamaica",
    "nom_it": "Giamaica",
    "nom_nl": "Jamaica",
    "nom_sv": "Jamaica",
    "nom_da": "Jamaica",
    "nom_no": "Jamaica",
    "nom_fi": "Jamaika"
  },
  "japan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/japan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/japan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/japan/flag.png",
    "nom_fr": "Japon",
    "nom_en": "Japan",
    "nom_de": "Japan",
    "nom_es": "Japón",
    "nom_pt": "Japão",
    "nom_it": "Giappone",
    "nom_nl": "Japan",
    "nom_sv": "Japan",
    "nom_da": "Japan",
    "nom_no": "Japan",
    "nom_fi": "Japani"
  },
  "jordan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/jordan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/jordan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillauxbinationaux/jerseys/jordan/flag.png",
    "nom_fr": "Jordanie",
    "nom_en": "Jordan",
    "nom_de": "Jordanien",
    "nom_es": "Jordania",
    "nom_pt": "Jordânia",
    "nom_it": "Giordania",
    "nom_nl": "Jordanië",
    "nom_sv": "Jordanien",
    "nom_da": "Jordan",
    "nom_no": "Jordan",
    "nom_fi": "Jordanialainen"
  },
  "kabylie": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kabylie/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kabylie/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kabylie/flag.png",
    "nom_fr": "Kabylie",
    "nom_en": "Kabylia",
    "nom_de": "Kabylei",
    "nom_es": "Cabilia",
    "nom_pt": "Cabília",
    "nom_it": "Cabilia",
    "nom_nl": "Kabylië",
    "nom_sv": "Kabylien",
    "nom_da": "Kabylien",
    "nom_no": "Kabylien",
    "nom_fi": "Kabylia"
  },
  "kazakhstan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kazakhstan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kazakhstan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kazakhstan/flag.png",
    "nom_fr": "Kazakhstan",
    "nom_en": "Kazakhstan",
    "nom_de": "Kasachstan",
    "nom_es": "Kazajistán",
    "nom_pt": "Cazaquistão",
    "nom_it": "Kazakistan",
    "nom_nl": "Kazachstan",
    "nom_sv": "Kazakstan",
    "nom_da": "Kasakhstan",
    "nom_no": "Kasakhstan",
    "nom_fi": "Kazakstan"
  },
  "kenya": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kenya/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kenya/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kenya/flag.png",
    "nom_fr": "Kenya",
    "nom_en": "Kenya",
    "nom_de": "Kenia",
    "nom_es": "Kenia",
    "nom_pt": "Quénia",
    "nom_it": "Kenya",
    "nom_nl": "Kenia",
    "nom_sv": "Kenya",
    "nom_da": "Kenya",
    "nom_no": "Kenya",
    "nom_fi": "Kenia"
  },
  "kosovo": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kosovo/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kosovo/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kosovo/flag.png",
    "nom_fr": "Kosovo",
    "nom_en": "Kosovo",
    "nom_de": "Kosovo",
    "nom_es": "Kosovo",
    "nom_pt": "Kosovo",
    "nom_it": "Kosovo",
    "nom_nl": "Kosovo",
    "nom_sv": "Kosovo",
    "nom_da": "Kosovo",
    "nom_no": "Kosovo",
    "nom_fi": "Kosovo"
  },
  "kuwait": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kuwait/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kuwait/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kuwait/flag.png",
    "nom_fr": "Koweït",
    "nom_en": "Kuwait",
    "nom_de": "Kuwait",
    "nom_es": "Kuwait",
    "nom_pt": "Kuwait",
    "nom_it": "Kuwait",
    "nom_nl": "Koeweit",
    "nom_sv": "Kuwait",
    "nom_da": "Kuwait",
    "nom_no": "Kuwait",
    "nom_fi": "Kuwait"
  },
  "kyrgyzstan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kyrgyzstan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kyrgyzstan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kyrgyzstan/flag.png",
    "nom_fr": "Kirghizistan",
    "nom_en": "Kyrgyzstan",
    "nom_de": "Kirgisistan",
    "nom_es": "Kirguistán",
    "nom_pt": "Quirguizistão",
    "nom_it": "Kirghizistan",
    "nom_nl": "Kirgizië",
    "nom_sv": "Kirgizistan",
    "nom_da": "Kirgisistan",
    "nom_no": "Kirgisistan",
    "nom_fi": "Kirgisia"
  },
  "laos": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/laos/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/laos/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/laos/flag.png",
    "nom_fr": "Laos",
    "nom_en": "Laos",
    "nom_de": "Laos",
    "nom_es": "Laos",
    "nom_pt": "Laos",
    "nom_it": "Laos",
    "nom_nl": "Laos",
    "nom_sv": "Laos",
    "nom_da": "Laos",
    "nom_no": "Laos",
    "nom_fi": "Laos"
  },
  "latvia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/latvia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/latvia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/latvia/flag.png",
    "nom_fr": "Lettonie",
    "nom_en": "Latvia",
    "nom_de": "Lettland",
    "nom_es": "Letonia",
    "nom_pt": "Letónia",
    "nom_it": "Lettonia",
    "nom_nl": "Letland",
    "nom_sv": "Lettland",
    "nom_da": "Letland",
    "nom_no": "Latvia",
    "nom_fi": "Latvia"
  },
  "lebanon": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lebanon/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lebanon/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lebanon/flag.png",
    "nom_fr": "Liban",
    "nom_en": "Lebanon",
    "nom_de": "Libanon",
    "nom_es": "Líbano",
    "nom_pt": "Líbano",
    "nom_it": "Libano",
    "nom_nl": "Libanon",
    "nom_sv": "Libanon",
    "nom_da": "Libanon",
    "nom_no": "Libanon",
    "nom_fi": "Libanon"
  },
  "lesotho": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lesotho/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lesotho/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lesotho/flag.png",
    "nom_fr": "Lesotho",
    "nom_en": "Lesotho",
    "nom_de": "Lesotho",
    "nom_es": "Lesoto",
    "nom_pt": "Lesoto",
    "nom_it": "Lesotho",
    "nom_nl": "Lesotho",
    "nom_sv": "Lesotho",
    "nom_da": "Lesotho",
    "nom_no": "Lesotho",
    "nom_fi": "Lesotho"
  },
  "liberia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/liberia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/liberia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/liberia/flag.png",
    "nom_fr": "Libéria",
    "nom_en": "Liberia",
    "nom_de": "Liberia",
    "nom_es": "Liberia",
    "nom_pt": "Libéria",
    "nom_it": "Liberia",
    "nom_nl": "Liberia",
    "nom_sv": "Liberia",
    "nom_da": "Liberia",
    "nom_no": "Liberia",
    "nom_fi": "Liberia"
  },
  "libya": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/libya/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/libya/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/libya/flag.png",
    "nom_fr": "Libye",
    "nom_en": "Libya",
    "nom_de": "Libyen",
    "nom_es": "Libia",
    "nom_pt": "Líbia",
    "nom_it": "Libia",
    "nom_nl": "Libië",
    "nom_sv": "Libyen",
    "nom_da": "Libyen",
    "nom_no": "Libya",
    "nom_fi": "Libya"
  },
  "liechtenstein": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/liechtenstein/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/liechtenstein/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/liechtenstein/flag.png",
    "nom_fr": "Liechtenstein",
    "nom_en": "Liechtenstein",
    "nom_de": "Liechtenstein",
    "nom_es": "Liechtenstein",
    "nom_pt": "Liechtenstein",
    "nom_it": "Liechtenstein",
    "nom_nl": "Liechtenstein",
    "nom_sv": "Liechtenstein",
    "nom_da": "Liechtenstein",
    "nom_no": "Liechtenstein",
    "nom_fi": "Liechtenstein"
  },
  "lithuania": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lithuania/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lithuania/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lithuania/flag.png",
    "nom_fr": "Lituanie",
    "nom_en": "Lithuania",
    "nom_de": "Litauen",
    "nom_es": "Lituania",
    "nom_pt": "Lituânia",
    "nom_it": "Lituania",
    "nom_nl": "Litouwen",
    "nom_sv": "Litauen",
    "nom_da": "Litauen",
    "nom_no": "Litauen",
    "nom_fi": "Liettua"
  },
  "lorraine": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lorraine/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lorraine/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/lorraine/flag.png",
    "nom_fr": "Lorraine",
    "nom_en": "Lorraine",
    "nom_de": "Lothringen",
    "nom_es": "Lorena",
    "nom_pt": "Lorena",
    "nom_it": "Lorena",
    "nom_nl": "Lotharingen",
    "nom_sv": "Lothringen",
    "nom_da": "Lothringen",
    "nom_no": "Lothringen",
    "nom_fi": "Lothringen"
  },
  "luxembourg": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/luxembourg/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/luxembourg/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/luxembourg/flag.png",
    "nom_fr": "Luxembourg",
    "nom_en": "Luxembourg",
    "nom_de": "Luxemburg",
    "nom_es": "Luxemburgo",
    "nom_pt": "Luxemburgo",
    "nom_it": "Lussemburgo",
    "nom_nl": "Luxemburg",
    "nom_sv": "Luxemburg",
    "nom_da": "Luxembourg",
    "nom_no": "Luxembourg",
    "nom_fi": "Luxembourg"
  },
  "macau": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/macau/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/macau/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/macau/flag.png",
    "nom_fr": "Macao",
    "nom_en": "Macau",
    "nom_de": "Macau",
    "nom_es": "Macao",
    "nom_pt": "Macau",
    "nom_it": "Macao",
    "nom_nl": "Macau",
    "nom_sv": "Macao",
    "nom_da": "Macao",
    "nom_no": "Macao",
    "nom_fi": "Macao"
  },
  "madagascar": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/madagascar/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/madagascar/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/madagascar/flag.png",
    "nom_fr": "Madagascar",
    "nom_en": "Madagascar",
    "nom_de": "Madagaskar",
    "nom_es": "Madagascar",
    "nom_pt": "Madagáscar",
    "nom_it": "Madagascar",
    "nom_nl": "Madagaskar",
    "nom_sv": "Madagaskar",
    "nom_da": "Madagaskar",
    "nom_no": "Madagaskar",
    "nom_fi": "Madagaskar"
  },
  "malawi": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malawi/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malawi/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malawi/flag.png",
    "nom_fr": "Malawi",
    "nom_en": "Malawi",
    "nom_de": "Malawi",
    "nom_es": "Malaui",
    "nom_pt": "Malawi",
    "nom_it": "Malawi",
    "nom_nl": "Malawi",
    "nom_sv": "Malawi",
    "nom_da": "Malawi",
    "nom_no": "Malawi",
    "nom_fi": "Malawi"
  },
  "malaysia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malaysia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malaysia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malaysia/flag.png",
    "nom_fr": "Malaisie",
    "nom_en": "Malaysia",
    "nom_de": "Malaysia",
    "nom_es": "Malasia",
    "nom_pt": "Malásia",
    "nom_it": "Malesia",
    "nom_nl": "Maleisië",
    "nom_sv": "Malaysia",
    "nom_da": "Malaysia",
    "nom_no": "Malaysia",
    "nom_fi": "Malesia"
  },
  "mali": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mali/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mali/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mali/flag.png",
    "nom_fr": "Mali",
    "nom_en": "Mali",
    "nom_de": "Mali",
    "nom_es": "Malí",
    "nom_pt": "Mali",
    "nom_it": "Mali",
    "nom_nl": "Mali",
    "nom_sv": "Mali",
    "nom_da": "Mali",
    "nom_no": "Mali",
    "nom_fi": "Mali"
  },
  "malta": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malta/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malta/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/malta/flag.png",
    "nom_fr": "Malte",
    "nom_en": "Malta",
    "nom_de": "Malta",
    "nom_es": "Malta",
    "nom_pt": "Malta",
    "nom_it": "Malta",
    "nom_nl": "Malta",
    "nom_sv": "Malta",
    "nom_da": "Malta",
    "nom_no": "Malta",
    "fi": "Malta"
  },
  "martinique": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/martinique/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/martinique/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/martinique/flag.png",
    "nom_fr": "Martinique",
    "nom_en": "Martinique",
    "nom_de": "Martinique",
    "nom_es": "Martinica",
    "nom_pt": "Martinica",
    "nom_it": "Martinica",
    "nom_nl": "Martinique",
    "nom_sv": "Martinique",
    "nom_da": "Martinique",
    "nom_no": "Martinique",
    "nom_fi": "Martinique"
  },
  "mauritania": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mauritania/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mauritania/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mauritania/flag.png",
    "nom_fr": "Mauritanie",
    "nom_en": "Mauritania",
    "nom_de": "Mauretanien",
    "nom_es": "Mauritania",
    "nom_pt": "Mauritânia",
    "nom_it": "Mauritania",
    "nom_nl": "Mauritanië",
    "nom_sv": "Mauretanien",
    "nom_da": "Mauretanien",
    "nom_no": "Mauritania",
    "nom_fi": "Mauritania"
  },
  "mauritius": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mauritius/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mauritius/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mauritius/flag.png",
    "nom_fr": "Maurice",
    "nom_en": "Mauritius",
    "nom_de": "Mauritius",
    "nom_es": "Mauricio",
    "nom_pt": "Maurícia",
    "nom_it": "Mauritius",
    "nom_nl": "Mauritius",
    "nom_sv": "Mauritius",
    "nom_da": "Mauritius",
    "nom_no": "Mauritius",
    "nom_fi": "Mauritius"
  },
  "mayotte": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mayotte/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mayotte/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mayotte/flag.png",
    "nom_fr": "Mayotte",
    "nom_en": "Mayotte",
    "nom_de": "Mayotte",
    "nom_es": "Mayotte",
    "nom_pt": "Mayotte",
    "nom_it": "Mayotte",
    "nom_nl": "Mayotte",
    "nom_sv": "Mayotte",
    "nom_da": "Mayotte",
    "nom_no": "Mayotte",
    "nom_fi": "Mayotte"
  },
  "mexico": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mexico/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mexico/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mexico/flag.png",
    "nom_fr": "Mexique",
    "nom_en": "Mexico",
    "nom_de": "Mexiko",
    "nom_es": "México",
    "nom_pt": "México",
    "nom_it": "Messico",
    "nom_nl": "Mexico",
    "nom_sv": "Mexiko",
    "nom_da": "Mexico",
    "nom_no": "Mexico",
    "nom_fi": "Meksiko"
  },
  "micronesia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/micronesia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/micronesia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/micronesia/flag.png",
    "nom_fr": "Micronésie",
    "nom_en": "Micronesia",
    "nom_de": "Mikronesien",
    "nom_es": "Micronesia",
    "nom_pt": "Micronésia",
    "nom_it": "Micronesia",
    "nom_nl": "Micronesia",
    "nom_sv": "Mikronesiska federationen",
    "nom_da": "Mikronesien",
    "nom_no": "Mikronesiaføderasjonen",
    "nom_fi": "Mikronesia"
  },
  "moldova": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/moldova/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/moldova/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/moldova/flag.png",
    "nom_fr": "Moldavie",
    "nom_en": "Moldova",
    "nom_de": "Moldawien",
    "nom_es": "Moldavia",
    "nom_pt": "Moldávia",
    "nom_it": "Moldavia",
    "nom_nl": "Moldavië",
    "nom_sv": "Moldavien",
    "nom_da": "Moldova",
    "nom_no": "Moldova",
    "nom_fi": "Moldova"
  },
  "montenegro": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/montenegro/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/montenegro/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/montenegro/flag.png",
    "nom_fr": "Monténégro",
    "nom_en": "Montenegro",
    "nom_de": "Montenegro",
    "nom_es": "Montenegro",
    "nom_pt": "Montenegro",
    "nom_it": "Montenegro",
    "nom_nl": "Montenegro",
    "nom_sv": "Montenegro",
    "nom_da": "Montenegro",
    "nom_no": "Montenegro",
    "nom_fi": "Montenegro"
  },
  "montserrat": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/montserrat/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/montserrat/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/montserrat/flag.png",
    "nom_fr": "Montserrat",
    "nom_en": "Montserrat",
    "nom_de": "Montserrat",
    "nom_es": "Montserrat",
    "nom_pt": "Montserrat",
    "nom_it": "Montserrat",
    "nom_nl": "Montserrat",
    "nom_sv": "Montserrat",
    "nom_da": "Montserrat",
    "nom_no": "Montserrat",
    "nom_fi": "Montserrat"
  },
  "morocco": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/morocco/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/morocco/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/morocco/flag.png",
    "nom_fr": "Maroc",
    "nom_en": "Morocco",
    "nom_de": "Marokko",
    "nom_es": "Marruecos",
    "nom_pt": "Marrocos",
    "nom_it": "Marocco",
    "nom_nl": "Marokko",
    "nom_sv": "Marocko",
    "nom_da": "Marokko",
    "nom_no": "Marokko",
    "nom_fi": "Marokko"
  },
  "mozambique": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mozambique/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mozambique/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mozambique/flag.png",
    "nom_fr": "Mozambique",
    "nom_en": "Mozambique",
    "nom_de": "Mosambik",
    "nom_es": "Mozambique",
    "nom_pt": "Moçambique",
    "nom_it": "Mozambico",
    "nom_nl": "Mozambique",
    "nom_sv": "Moçambique",
    "nom_da": "Mozambique",
    "nom_no": "Mosambik",
    "nom_fi": "Mosambik"
  },
  "myanmar": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/myanmar/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/myanmar/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/myanmar/flag.png",
    "nom_fr": "Myanmar",
    "nom_en": "Myanmar",
    "nom_de": "Myanmar",
    "nom_es": "Myanmar",
    "nom_pt": "Myanmar",
    "nom_it": "Myanmar",
    "nom_nl": "Myanmar",
    "nom_sv": "Myanmar",
    "nom_da": "Myanmar",
    "nom_no": "Myanmar",
    "nom_fi": "Myanmar"
  },
  "namibia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/namibia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/namibia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/namibia/flag.png",
    "nom_fr": "Namibie",
    "nom_en": "Namibia",
    "nom_de": "Namibia",
    "nom_es": "Namibia",
    "nom_pt": "Namíbia",
    "nom_it": "Namibia",
    "nom_nl": "Namibië",
    "nom_sv": "Namibia",
    "nom_da": "Namibia",
    "nom_no": "Namibia",
    "nom_fi": "Namibia"
  },
  "netherlands": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/netherlands/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/netherlands/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/netherlands/flag.png",
    "nom_fr": "Pays-Bas",
    "nom_en": "Netherlands",
    "nom_de": "Niederlande",
    "nom_es": "Países Bajos",
    "nom_pt": "Países Baixos",
    "nom_it": "Paesi Bassi",
    "nom_nl": "Nederland",
    "nom_sv": "Nederländerna",
    "nom_da": "Nederlandene",
    "nom_no": "Nederland",
    "nom_fi": "Alankomaat"
  },
  "nicaragua": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nicaragua/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nicaragua/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nicaragua/flag.png",
    "nom_fr": "Nicaragua",
    "nom_en": "Nicaragua",
    "nom_de": "Nicaragua",
    "nom_es": "Nicaragua",
    "nom_pt": "Nicarágua",
    "nom_it": "Nicaragua",
    "nom_nl": "Nicaragua",
    "nom_sv": "Nicaragua",
    "nom_da": "Nicaragua",
    "nom_no": "Nicaragua",
    "nom_fi": "Nicaragua"
  },
  "niger": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/niger/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/niger/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/niger/flag.png",
    "nom_fr": "Niger",
    "nom_en": "Niger",
    "nom_de": "Niger",
    "nom_es": "Níger",
    "nom_pt": "Níger",
    "nom_it": "Niger",
    "nom_nl": "Niger",
    "nom_sv": "Niger",
    "nom_da": "Niger",
    "nom_no": "Niger",
    "nom_fi": "Niger"
  },
  "nigeria": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nigeria/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nigeria/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nigeria/flag.png",
    "nom_fr": "Nigéria",
    "nom_en": "Nigeria",
    "nom_de": "Nigeria",
    "nom_es": "Nigeria",
    "nom_pt": "Nigéria",
    "nom_it": "Nigeria",
    "nom_nl": "Nigeria",
    "nom_sv": "Nigeria",
    "nom_da": "Nigeria",
    "nom_no": "Nigeria",
    "nom_fi": "Nigeria"
  },
  "nord-pas-de-calais": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nord-pas-de-calais/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nord-pas-de-calais/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nord-pas-de-calais/flag.png",
    "nom_fr": "Nord-Pas-de-Calais",
    "nom_en": "Nord-Pas-de-Calais",
    "nom_de": "Nord-Pas-de-Calais",
    "nom_es": "Nord-Pas-de-Calais",
    "nom_pt": "Nord-Pas-de-Calais",
    "nom_it": "Nord-Passo di Calais",
    "nom_nl": "Noorderdepartement-Nauw van Calais",
    "nom_sv": "Nord-Pas-de-Calais",
    "nom_da": "Nord-Pas-de-Calais",
    "nom_no": "Nord-Pas-de-Calais",
    "nom_fi": "Nord-Pas-de-Calais"
  },
  "north-korea": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/north-korea/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/north-korea/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/north-korea/flag.png",
    "nom_fr": "Corée du Nord",
    "nom_en": "North Korea",
    "nom_de": "Nordkorea",
    "nom_es": "Corea del Norte",
    "nom_pt": "Corea do Norte",
    "nom_it": "Corea del Nord",
    "nom_nl": "Noord-Korea",
    "nom_sv": "Nordkorea",
    "nom_da": "Nordkorea",
    "nom_no": "Nord-Korea",
    "nom_fi": "Pohjois-Korea"
  },
  "north-macedonia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/north-macedonia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/north-macedonia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/north-macedonia/flag.png",
    "nom_fr": "Macédoine du Nord",
    "nom_en": "North Macedonia",
    "nom_de": "Nordmazedonien",
    "nom_es": "Macedonia del Norte",
    "nom_pt": "Macedónia do Norde",
    "nom_it": "Macedonia del Nord",
    "nom_nl": "Noord-Macedonië",
    "nom_sv": "Nordmacedonien",
    "nom_da": "Nordmakedonien",
    "nom_no": "Nord-Makedonia",
    "nom_fi": "Pohjois-Makedonia"
  },
  "norway": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/norway/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/norway/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/norway/flag.png",
    "nom_fr": "Norvège",
    "nom_en": "Norway",
    "nom_de": "Norwegen",
    "nom_es": "Noruega",
    "nom_pt": "Noruega",
    "nom_it": "Norvegia",
    "nom_nl": "Noorwegen",
    "nom_sv": "Norge",
    "nom_da": "Norge",
    "nom_no": "Norge",
    "nom_fi": "Norja"
  },
  "oman": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/oman/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/oman/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/oman/flag.png",
    "nom_fr": "Oman",
    "nom_en": "Oman",
    "nom_de": "Oman",
    "nom_es": "Omán",
    "nom_pt": "Omã",
    "nom_it": "Oman",
    "nom_nl": "Oman",
    "nom_sv": "Oman",
    "nom_da": "Oman",
    "nom_no": "Oman",
    "nom_fi": "Oman"
  },
  "pakistan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/pakistan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/pakistan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/pakistan/flag.png",
    "nom_fr": "Pakistan",
    "nom_en": "Pakistan",
    "nom_de": "Pakistan",
    "nom_es": "Pakistán",
    "nom_pt": "Paquistão",
    "nom_it": "Pakistan",
    "nom_nl": "Pakistan",
    "nom_sv": "Pakistan",
    "nom_da": "Pakistan",
    "nom_no": "Pakistan",
    "nom_fi": "Pakistan"
  },
  "palestine": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/palestine/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/palestine/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/palestine/flag.png",
    "nom_fr": "Palestine",
    "nom_en": "Palestine",
    "nom_de": "Palästina",
    "nom_es": "Palestina",
    "nom_pt": "Palestina",
    "nom_it": "Palestina",
    "nom_nl": "Palestina",
    "nom_sv": "Palestina",
    "nom_da": "Palæstina",
    "nom_no": "Palestina",
    "nom_fi": "Palestiina"
  },
  "papua-new-guinea": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/papua-new-guinea/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/papua-new-guinea/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/papua-new-guinea/flag.png",
    "nom_fr": "Papouasie-Nouvelle-Guinée",
    "nom_en": "Papua New Guinea",
    "nom_de": "Papua-Neuguinea",
    "nom_es": "Papúa Nueva Guinea",
    "nom_pt": "Papua-Nova Guiné",
    "nom_it": "Papua Nuova Guinea",
    "nom_nl": "Papoea-Nieuw-Guinea",
    "nom_sv": "Papua Nya Guinea",
    "nom_da": "Papua Ny Guinea",
    "nom_no": "Papua Ny-Guinea",
    "nom_fi": "Papua-Uusi-Guinea"
  },
  "paraguay": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/paraguay/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/paraguay/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/paraguay/flag.png",
    "nom_fr": "Paraguay",
    "nom_en": "Paraguay",
    "nom_de": "Paraguay",
    "nom_es": "Paraguay",
    "nom_pt": "Paraguai",
    "nom_it": "Paraguay",
    "nom_nl": "Paraguay",
    "nom_sv": "Paraguay",
    "nom_da": "Paraguay",
    "nom_no": "Paraguay",
    "nom_fi": "Paraguay"
  },
  "pays-basque": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/pays-basque/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/pays-basque/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/pays-basque/flag.png",
    "nom_fr": "Pays Basque",
    "nom_en": "Basque Country",
    "nom_de": "Baskenland",
    "nom_es": "País Vasco",
    "nom_pt": "País Vasco",
    "nom_it": "Paesi Baschi",
    "nom_nl": "Baskenland",
    "nom_sv": "Baskien",
    "nom_da": "Baskerlandet",
    "nom_no": "Baskerland",
    "nom_fi": "Baskimaa"
  },
  "peru": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/peru/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/peru/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/peru/flag.png",
    "nom_fr": "Pérou",
    "nom_en": "Peru",
    "nom_de": "Peru",
    "nom_es": "Perú",
    "nom_pt": "Peru",
    "nom_it": "Perù",
    "nom_nl": "Peru",
    "nom_sv": "Peru",
    "nom_da": "Peru",
    "nom_no": "Peru",
    "nom_fi": "Peru"
  },
  "philippines": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/philippines/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/philippines/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/philippines/flag.png",
    "nom_fr": "Philippines",
    "nom_en": "Philippines",
    "nom_de": "Philippinen",
    "nom_es": "Filipinas",
    "nom_pt": "Filipinas",
    "nom_it": "Filippine",
    "nom_nl": "Filipijnen",
    "nom_sv": "Filippinerna",
    "nom_da": "Filippinerne",
    "nom_no": "Filippinene",
    "nom_fi": "Filippiinit"
  },
  "picardie": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/picardie/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/picardie/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/picardie/flag.png",
    "nom_fr": "Picardie",
    "nom_en": "Picardy",
    "nom_de": "Picardie",
    "nom_es": "Picardía",
    "nom_pt": "Picardia",
    "nom_it": "Piccardia",
    "nom_nl": "Picardië",
    "nom_sv": "Picardie",
    "nom_da": "Picardie",
    "nom_no": "Picardie",
    "nom_fi": "Picardie"
  },
  "poland": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/poland/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/poland/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/poland/flag.png",
    "nom_fr": "Pologne",
    "nom_en": "Poland",
    "nom_de": "Polen",
    "nom_es": "Polonia",
    "nom_pt": "Polónia",
    "nom_it": "Polonia",
    "nom_nl": "Polen",
    "nom_sv": "Polen",
    "nom_da": "Polen",
    "nom_no": "Polen",
    "nom_fi": "Puola"
  },
  "portugal": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/portugal/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/portugal/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/portugal/flag.png",
    "nom_fr": "Portugal",
    "nom_en": "Portugal",
    "nom_de": "Portugal",
    "nom_es": "Portugal",
    "nom_pt": "Portugal",
    "nom_it": "Portogallo",
    "nom_nl": "Portugal",
    "nom_sv": "Portugal",
    "nom_da": "Portugal",
    "nom_no": "Portugal",
    "nom_fi": "Portugali"
  },
  "qatar": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/qatar/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/qatar/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/qatar/flag.png",
    "nom_fr": "Qatar",
    "nom_en": "Qatar",
    "nom_de": "Katar",
    "nom_es": "Catar",
    "nom_pt": "Catar",
    "nom_it": "Qatar",
    "nom_nl": "Qatar",
    "nom_sv": "Qatar",
    "nom_da": "Qatar",
    "nom_no": "Qatar",
    "nom_fi": "Qatar"
  },
  "reunion": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/reunion/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/reunion/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/reunion/flag.png",
    "nom_fr": "La Réunion",
    "nom_en": "Réunion",
    "nom_de": "Réunion",
    "nom_es": "Reunión",
    "nom_pt": "Reunião",
    "nom_it": "Riunione",
    "nom_nl": "Réunion",
    "nom_sv": "Réunion",
    "nom_da": "Réunion",
    "nom_no": "Réunion",
    "nom_fi": "Réunion"
  },
  "rif": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/rif/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/rif/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/rif/flag.png",
    "nom_fr": "Rif",
    "nom_en": "Rif",
    "nom_de": "Rif",
    "nom_es": "Rif",
    "nom_pt": "Rif",
    "nom_it": "Rif",
    "nom_nl": "Rif",
    "nom_sv": "Rif",
    "nom_da": "Rif",
    "nom_no": "Rif",
    "nom_fi": "Rif"
  },
  "romania": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/romania/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/romania/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/romania/flag.png",
    "nom_fr": "Roumanie",
    "nom_en": "Romania",
    "nom_de": "Rumänien",
    "nom_es": "Rumania",
    "nom_pt": "Roménia",
    "nom_it": "Romania",
    "nom_nl": "Roemenië",
    "nom_sv": "Rumänien",
    "nom_da": "Rumænien",
    "nom_no": "Romania",
    "nom_fi": "Romania"
  },
  "russia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/russia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/russia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/russia/flag.png",
    "nom_fr": "Russie",
    "nom_en": "Russia",
    "nom_de": "Russland",
    "nom_es": "Rusia",
    "nom_pt": "Rússia",
    "nom_it": "Russia",
    "nom_nl": "Rusland",
    "nom_sv": "Ryssland",
    "nom_da": "Rusland",
    "nom_no": "Russland",
    "nom_fi": "Venäjä"
  },
  "rwanda": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/rwanda/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/rwanda/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/rwanda/flag.png",
    "nom_fr": "Rwanda",
    "nom_en": "Rwanda",
    "nom_de": "Ruanda",
    "nom_es": "Ruanda",
    "nom_pt": "Ruanda",
    "nom_it": "Ruanda",
    "nom_nl": "Rwanda",
    "nom_sv": "Rwanda",
    "nom_da": "Rwanda",
    "nom_no": "Rwanda",
    "nom_fi": "Rwanda"
  },
  "saint-kitts-and-nevis": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saint-kitts-and-nevis/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saint-kitts-and-nevis/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saint-kitts-and-nevis/flag.png",
    "nom_fr": "Saint-Christophe-et-Niévès",
    "nom_en": "Saint Kitts and Nevis",
    "nom_de": "St. Kitts und Nevis",
    "nom_es": "San Cristóbal y Nieves",
    "nom_pt": "São Cristóvão e Neves",
    "nom_it": "Saint Kitts e Nevis",
    "nom_nl": "Saint Kitts and Nevis",
    "nom_sv": "Saint Kitts och Nevis",
    "nom_da": "Saint Kitts og Nevis",
    "nom_no": "Saint Kitts og Nevis",
    "nom_fi": "Saint Kitts ja Nevis"
  },
  "samoa": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/samoa/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/samoa/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/samoa/flag.png",
    "nom_fr": "Samoa",
    "nom_en": "Samoa",
    "nom_de": "Samoa",
    "nom_es": "Samoa",
    "nom_pt": "Samoa",
    "nom_it": "Samoa",
    "nom_nl": "Samoa",
    "nom_sv": "Samoa",
    "nom_da": "Samoa",
    "nom_no": "Samoa",
    "nom_fi": "Samoa"
  },
  "san-marino": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/san-marino/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/san-marino/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/san-marino/flag.png",
    "nom_fr": "Saint-Marin",
    "nom_en": "San Marino",
    "nom_de": "San Marino",
    "nom_es": "San Marino",
    "nom_pt": "San Marino",
    "nom_it": "San Marino",
    "nom_nl": "San Marino",
    "nom_sv": "San Marino",
    "nom_da": "San Marino",
    "nom_no": "San Marino",
    "nom_fi": "San Marino"
  },
  "sao-tome-and-principe": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sao-tome-and-principe/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sao-tome-and-principe/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sao-tome-and-principe/flag.png",
    "nom_fr": "Sao Tomé-et-Principe",
    "nom_en": "Sao Tome and Principe",
    "nom_de": "São Tomé und Príncipe",
    "nom_es": "Santo Tomé y Príncipe",
    "nom_pt": "São Tome e Príncipe",
    "nom_it": "São Tomé e Príncipe",
    "nom_nl": "Sao Tomé e Principe",
    "nom_sv": "São Tomé och Príncipe",
    "nom_da": "São Tomé og Príncipe",
    "nom_no": "São Tomé og Príncipe",
    "nom_fi": "São Tomé ja Príncipe"
  },
  "saudi-arabia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saudi-arabia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saudi-arabia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saudi-arabia/flag.png",
    "nom_fr": "Arabie Saoudite",
    "nom_en": "Saudi Arabia",
    "nom_de": "Saudi-Arabien",
    "nom_es": "Arabia Saudita",
    "nom_pt": "Arábia Saudita",
    "nom_it": "Arabia Saudita",
    "nom_nl": "Saoedi-Arabië",
    "nom_sv": "Saudiarabien",
    "nom_da": "Saudi-Arabien",
    "nom_no": "Saudi-Arabia",
    "nom_fi": "Saudi-Arabia"
  },
  "savoie": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/savoie/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/savoie/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/savoie/flag.png",
    "nom_fr": "Savoie",
    "nom_en": "Savoy",
    "nom_de": "Savoyen",
    "nom_es": "Saboya",
    "nom_pt": "Saboia",
    "nom_it": "Savoia",
    "nom_nl": "Savoye",
    "nom_sv": "Savojen",
    "nom_da": "Savoyen",
    "nom_no": "Savoie",
    "nom_fi": "Savoie"
  },
  "scotland": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/scotland/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/scotland/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/scotland/flag.png",
    "nom_fr": "Écosse",
    "nom_en": "Scotland",
    "nom_de": "Schottland",
    "nom_es": "Escocia",
    "nom_pt": "Escócia",
    "nom_it": "Scozia",
    "nom_nl": "Schotland",
    "nom_sv": "Skottland",
    "nom_da": "Skotland",
    "nom_no": "Skottland",
    "nom_fi": "Skotlanti"
  },
  "senegal": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/senegal/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/senegal/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/senegal/flag.png",
    "nom_fr": "Sénégal",
    "nom_en": "Senegal",
    "nom_de": "Senegal",
    "nom_es": "Senegal",
    "nom_pt": "Senegal",
    "nom_it": "Senegal",
    "nom_nl": "Senegal",
    "nom_sv": "Senegal",
    "nom_da": "Senegal",
    "nom_no": "Senegal",
    "nom_fi": "Senegal"
  },
  "serbia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/serbia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/serbia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/serbia/flag.png",
    "nom_fr": "Serbie",
    "nom_en": "Serbia",
    "nom_de": "Serbien",
    "nom_es": "Serbia",
    "nom_pt": "Sérvia",
    "nom_it": "Serbia",
    "nom_nl": "Servië",
    "nom_sv": "Serbien",
    "nom_da": "Serbien",
    "nom_no": "Serbia",
    "nom_fi": "Serbia"
  },
  "seychelles": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/seychelles/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/seychelles/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/seychelles/flag.png",
    "nom_fr": "Seychelles",
    "nom_en": "Seychelles",
    "nom_de": "Seychellen",
    "nom_es": "Seychelles",
    "nom_pt": "Seychelles",
    "nom_it": "Seychelles",
    "nom_nl": "Seychellen",
    "nom_sv": "Seychellerna",
    "nom_da": "Seychellerne",
    "nom_no": "Seychellene",
    "nom_fi": "Seychellit"
  },
  "sierra-leone": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sierra-leone/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sierra-leone/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sierra-leone/flag.png",
    "nom_fr": "Sierra Leone",
    "nom_en": "Sierra Leone",
    "nom_de": "Sierra Leone",
    "nom_es": "Sierra Leona",
    "nom_pt": "Serra Leoa",
    "nom_it": "Sierra Leone",
    "nom_nl": "Sierra Leone",
    "nom_sv": "Sierra Leone",
    "nom_da": "Sierra Leone",
    "nom_no": "Sierra Leone",
    "nom_fi": "Sierra Leone"
  },
  "singapore": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/singapore/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/singapore/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/singapore/flag.png",
    "nom_fr": "Singapour",
    "nom_en": "Singapore",
    "nom_de": "Singapur",
    "nom_es": "Singapur",
    "nom_pt": "Singapura",
    "nom_it": "Singapore",
    "nom_nl": "Singapore",
    "nom_sv": "Singapore",
    "nom_da": "Singapore",
    "nom_no": "Singapore",
    "nom_fi": "Singapore"
  },
  "slovakia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/slovakia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/slovakia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/slovakia/flag.png",
    "nom_fr": "Slovaquie",
    "nom_en": "Slovakia",
    "nom_de": "Slowakei",
    "nom_es": "Eslovaquia",
    "nom_pt": "Eslováquia",
    "nom_it": "Slovacchia",
    "nom_nl": "Slowakije",
    "nom_sv": "Slovakien",
    "nom_da": "Slovakiet",
    "nom_no": "Slovakia",
    "nom_fi": "Slovakia"
  },
  "slovenia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/slovenia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/slovenia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/slovenia/flag.png",
    "nom_fr": "Slovénie",
    "nom_en": "Slovenia",
    "nom_de": "Slowenien",
    "nom_es": "Eslovenia",
    "nom_pt": "Eslovénia",
    "nom_it": "Slovenia",
    "nom_nl": "Slovenië",
    "nom_sv": "Slovenien",
    "nom_da": "Slovenien",
    "nom_no": "Slovenia",
    "nom_fi": "Slovenia"
  },
  "solomon-islands": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/solomon-islands/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/solomon-islands/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/solomon-islands/flag.png",
    "nom_fr": "Îles Salomon",
    "nom_en": "Solomon Islands",
    "nom_de": "Salomonen",
    "nom_es": "Islas Salomón",
    "nom_pt": "Ilhas Salomão",
    "nom_it": "Isole Salomone",
    "nom_nl": "Salomonseilanden",
    "nom_sv": "Salomonöarna",
    "nom_da": "Salomonøerne",
    "nom_no": "Salomonøyene",
    "nom_fi": "Salomonsaaret"
  },
  "somalia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/somalia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/somalia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/somalia/flag.png",
    "nom_fr": "Somalie",
    "nom_en": "Somalia",
    "nom_de": "Somalia",
    "nom_es": "Somalia",
    "nom_pt": "Somália",
    "nom_it": "Somalia",
    "nom_nl": "Somalië",
    "nom_sv": "Somalia",
    "nom_da": "Somalia",
    "nom_no": "Somalia",
    "nom_fi": "Somalia"
  },
  "south-africa": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-africa/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-africa/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-africa/flag.png",
    "nom_fr": "Afrique du Sud",
    "nom_en": "South Africa",
    "nom_de": "Südafrika",
    "nom_es": "Sudáfrica",
    "nom_pt": "África do Sul",
    "nom_it": "Sudafrica",
    "nom_nl": "Zuid-Afrika",
    "nom_sv": "Sydafrika",
    "nom_da": "Sydafrika",
    "nom_no": "Sør-Afrika",
    "nom_fi": "Etelä-Afrikka"
  },
  "south-korea": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-korea/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-korea/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-korea/flag.png",
    "nom_fr": "Corée du Sud",
    "nom_en": "South Korea",
    "nom_de": "Südkorea",
    "nom_es": "Corea del Sur",
    "nom_pt": "Coreia do Sul",
    "nom_it": "Corea del Sud",
    "nom_nl": "Zuid-Korea",
    "nom_sv": "Sydkorea",
    "nom_da": "Sydkorea",
    "nom_no": "Sør-Korea",
    "nom_fi": "Etelä-Korea"
  },
  "spain": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/spain/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/spain/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/spain/flag.png",
    "nom_fr": "Espagne",
    "nom_en": "Spain",
    "nom_de": "Spanien",
    "nom_es": "España",
    "nom_pt": "Espanha",
    "nom_it": "Spagna",
    "nom_nl": "Spanje",
    "nom_sv": "Spanien",
    "nom_da": "Spanien",
    "nom_no": "Spania",
    "nom_fi": "Espanja"
  },
  "sri-lanka": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sri-lanka/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sri-lanka/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sri-lanka/flag.png",
    "nom_fr": "Sri Lanka",
    "nom_en": "Sri Lanka",
    "nom_de": "Sri Lanka",
    "nom_es": "Sri Lanka",
    "nom_pt": "Sri Lanka",
    "nom_it": "Sri Lanka",
    "nom_nl": "Sri Lanka",
    "nom_sv": "Sri Lanka",
    "nom_da": "Sri Lanka",
    "nom_no": "Sri Lanka",
    "nom_fi": "Sri Lanka"
  },
  "sudan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sudan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sudan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sudan/flag.png",
    "nom_fr": "Soudan",
    "nom_en": "Sudan",
    "nom_de": "Sudan",
    "nom_es": "Sudán",
    "nom_pt": "Sudão",
    "nom_it": "Sudan",
    "nom_nl": "Soedan",
    "nom_sv": "Sudan",
    "nom_da": "Sudan",
    "nom_no": "Sudan",
    "nom_fi": "Sudan"
  },
  "suriname": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/suriname/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/suriname/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/suriname/flag.png",
    "nom_fr": "Suriname",
    "nom_en": "Suriname",
    "nom_de": "Suriname",
    "nom_es": "Surinam",
    "nom_pt": "Suriname",
    "nom_it": "Suriname",
    "nom_nl": "Suriname",
    "nom_sv": "Suriname",
    "nom_da": "Suriname",
    "nom_no": "Suriname",
    "nom_fi": "Suriname"
  },
  "sweden": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sweden/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sweden/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/sweden/flag.png",
    "nom_fr": "Suède",
    "nom_en": "Sweden",
    "nom_de": "Schweden",
    "nom_es": "Suecia",
    "nom_pt": "Suécia",
    "nom_it": "Svezia",
    "nom_nl": "Zweden",
    "nom_sv": "Sverige",
    "nom_da": "Sverige",
    "nom_no": "Sverige",
    "nom_fi": "Ruotsi"
  },
  "switzerland": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/switzerland/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/switzerland/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/switzerland/flag.png",
    "nom_fr": "Suisse",
    "nom_en": "Switzerland",
    "nom_de": "Schweiz",
    "nom_es": "Suiza",
    "nom_pt": "Suíça",
    "nom_it": "Svizzera",
    "nom_nl": "Zwitserland",
    "nom_sv": "Schweiz",
    "nom_da": "Schweiz",
    "nom_no": "Sveits",
    "nom_fi": "Sveitsi"
  },
  "syria": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/syria/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/syria/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/syria/flag.png",
    "nom_fr": "Syrie",
    "nom_en": "Syria",
    "nom_de": "Syrien",
    "nom_es": "Siria",
    "nom_pt": "Síria",
    "nom_it": "Siria",
    "nom_nl": "Syrië",
    "nom_sv": "Syrien",
    "nom_da": "Syrien",
    "nom_no": "Syria",
    "nom_fi": "Syyria"
  },
  "tahiti": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tahiti/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tahiti/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tahiti/flag.png",
    "nom_fr": "Tahiti",
    "nom_en": "Tahiti",
    "nom_de": "Tahiti",
    "nom_es": "Tahití",
    "nom_pt": "Taiti",
    "nom_it": "Tahiti",
    "nom_nl": "Tahiti",
    "nom_sv": "Tahiti",
    "nom_da": "Tahiti",
    "nom_no": "Tahiti",
    "nom_fi": "Tahiti"
  },
  "taiwan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/taiwan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/taiwan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/taiwan/flag.png",
    "nom_fr": "Taïwan",
    "nom_en": "Taiwan",
    "nom_de": "Taiwan",
    "nom_es": "Taiwán",
    "nom_pt": "Taiwan",
    "nom_it": "Taiwan",
    "nom_nl": "Taiwan",
    "nom_sv": "Taiwan",
    "nom_da": "Taiwan",
    "nom_no": "Taiwan",
    "nom_fi": "Taiwan"
  },
  "tajikistan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tajikistan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tajikistan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tajikistan/flag.png",
    "nom_fr": "Tadjikistan",
    "nom_en": "Tajikistan",
    "nom_de": "Tadschikistan",
    "nom_es": "Tayikistán",
    "nom_pt": "Tajiquistão",
    "nom_it": "Tagikistan",
    "nom_nl": "Tadzjikistan",
    "nom_sv": "Tadzjikistan",
    "nom_da": "Tadsjikistan",
    "nom_no": "Tadsjikistan",
    "nom_fi": "Tadžikistan"
  },
  "tanzania": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tanzania/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tanzania/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tanzania/flag.png",
    "nom_fr": "Tanzanie",
    "nom_en": "Tanzania",
    "nom_de": "Tansania",
    "nom_es": "Tanzania",
    "nom_pt": "Tanzânia",
    "nom_it": "Tanzania",
    "nom_nl": "Tanzania",
    "nom_sv": "Tanzania",
    "nom_da": "Tanzania",
    "nom_no": "Tanzania",
    "nom_fi": "Tansania"
  },
  "thailand": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/thailand/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/thailand/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/thailand/flag.png",
    "nom_fr": "Thaïlande",
    "nom_en": "Thailand",
    "nom_de": "Thailand",
    "nom_es": "Tailandia",
    "nom_pt": "Tailândia",
    "nom_it": "Thailandia",
    "nom_nl": "Thailand",
    "nom_sv": "Thailand",
    "nom_da": "Thailand",
    "nom_no": "Thailand",
    "nom_fi": "Thaimaa"
  },
  "togo": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/togo/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/togo/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/togo/flag.png",
    "nom_fr": "Togo",
    "nom_en": "Togo",
    "nom_de": "Togo",
    "nom_es": "Togo",
    "nom_pt": "Togo",
    "nom_it": "Togo",
    "nom_nl": "Togo",
    "nom_sv": "Togo",
    "nom_da": "Togo",
    "nom_no": "Togo",
    "nom_fi": "Togo"
  },
  "trinidad-and-tobago": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/trinidad-and-tobago/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/trinidad-and-tobago/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/trinidad-and-tobago/flag.png",
    "nom_fr": "Trinité-et-Tobago",
    "nom_en": "Trinidad and Tobago",
    "nom_de": "Trinidad und Tobago",
    "nom_es": "Trinidad y Tobago",
    "nom_pt": "Trindade e Tobago",
    "nom_it": "Trinidad e Tobago",
    "nom_nl": "Trinidad and Tobago",
    "nom_sv": "Trinidad och Tobago",
    "nom_da": "Trinidad og Tobago",
    "nom_no": "Trinidad og Tobago",
    "nom_fi": "Trinidad ja Tobago"
  },
  "tuareg": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tuareg/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tuareg/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tuareg/flag.png",
    "nom_fr": "Touareg",
    "nom_en": "Tuareg",
    "nom_de": "Tuareg",
    "nom_es": "Tuareg",
    "nom_pt": "Tuareg",
    "nom_it": "Tuareg",
    "nom_nl": "Tuareg",
    "nom_sv": "Tuareg",
    "nom_da": "Tuareg",
    "nom_no": "Tuareg",
    "nom_fi": "Tuareg"
  },
  "tunisia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tunisia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tunisia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/tunisia/flag.png",
    "nom_fr": "Tunisie",
    "nom_en": "Tunisia",
    "nom_de": "Tunesien",
    "nom_es": "Túnez",
    "nom_pt": "Tunísia",
    "nom_it": "Tunisia",
    "nom_nl": "Tunesië",
    "nom_sv": "Tunisien",
    "nom_da": "Tunesien",
    "nom_no": "Tunisia",
    "nom_fi": "Tunisia"
  },
  "turkey": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/turkey/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/turkey/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/turkey/flag.png",
    "nom_fr": "Turquie",
    "nom_en": "Turkey",
    "nom_de": "Türkei",
    "nom_es": "Turquía",
    "nom_pt": "Turquia",
    "nom_it": "Turchia",
    "nom_nl": "Turkije",
    "nom_sv": "Turkiet",
    "nom_da": "Tyrkiet",
    "nom_no": "Tyrkia",
    "nom_fi": "Turkki"
  },
  "turkmenistan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/turkmenistan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/turkmenistan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/turkmenistan/flag.png",
    "nom_fr": "Turkménistan",
    "nom_en": "Turkmenistan",
    "nom_de": "Turkmenistan",
    "nom_es": "Turkmenistán",
    "nom_pt": "Turquemenistão",
    "nom_it": "Turkmenistan",
    "nom_nl": "Turkmenistan",
    "nom_sv": "Turkmenistan",
    "nom_da": "Turkmenistan",
    "nom_no": "Turkmenistan",
    "nom_fi": "Turkmenistan"
  },
  "uganda": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uganda/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uganda/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uganda/flag.png",
    "nom_fr": "Ouganda",
    "nom_en": "Uganda",
    "nom_de": "Uganda",
    "nom_es": "Uganda",
    "nom_pt": "Uganda",
    "nom_it": "Uganda",
    "nom_nl": "Oeganda",
    "nom_sv": "Uganda",
    "nom_da": "Uganda",
    "nom_no": "Uganda",
    "nom_fi": "Uganda"
  },
  "ukraine": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ukraine/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ukraine/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/ukraine/flag.png",
    "nom_fr": "Ukraine",
    "nom_en": "Ukraine",
    "nom_de": "Ukraine",
    "nom_es": "Ucrania",
    "nom_pt": "Ucrânia",
    "nom_it": "Ucraina",
    "nom_nl": "Oekraïne",
    "nom_sv": "Ukraina",
    "nom_da": "Ukraine",
    "nom_no": "Ukraina",
    "nom_fi": "Ukraina"
  },
  "united-arab-emirates": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/united-arab-emirates/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/united-arab-emirates/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/united-arab-emirates/flag.png",
    "nom_fr": "Émirats arabes unis",
    "nom_en": "United Arab Emirates",
    "nom_de": "Vereinigte Arabische Emirate",
    "nom_es": "Emiratos Árabes Unidos",
    "nom_pt": "Emirados Árabes Unidos",
    "nom_it": "Emirati Arabi Uniti",
    "nom_nl": "Verenigde Arabische Emiraten",
    "nom_sv": "Förenade Arabemiraten",
    "nom_da": "Forenede Arabiske Emirater",
    "nom_no": "De forente arabiske emirater",
    "nom_fi": "Yhdistyneet arabiemiirikunnat"
  },
  "united-states-of-america": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/united-states-of-america/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/united-states-of-america/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/united-states-of-america/flag.png",
    "nom_fr": "États-Unis",
    "nom_en": "United States",
    "nom_de": "Vereinigte Staaten",
    "nom_es": "Estados Unidos",
    "nom_pt": "Estados Unidos",
    "nom_it": "Stati Uniti",
    "nom_nl": "Verenigde Staten",
    "nom_sv": "USA",
    "nom_da": "USA",
    "nom_no": "USA",
    "nom_fi": "Yhdysvallat"
  },
  "uruguay": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uruguay/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uruguay/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uruguay/flag.png",
    "nom_fr": "Uruguay",
    "nom_en": "Uruguay",
    "nom_de": "Uruguay",
    "nom_es": "Uruguay",
    "nom_pt": "Uruguai",
    "nom_it": "Uruguay",
    "nom_nl": "Uruguay",
    "nom_sv": "Uruguay",
    "nom_da": "Uruguay",
    "nom_no": "Uruguay",
    "nom_fi": "Uruguay"
  },
  "uzbekistan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uzbekistan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uzbekistan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/uzbekistan/flag.png",
    "nom_fr": "Ouzbékistan",
    "nom_en": "Uzbekistan",
    "nom_de": "Usbekistan",
    "nom_es": "Uzbekistán",
    "nom_pt": "Usbequistão",
    "nom_it": "Uzbekistan",
    "nom_nl": "Oezbekistan",
    "nom_sv": "Uzbekistan",
    "nom_da": "Usbekistan",
    "nom_no": "Usbekistan",
    "nom_fi": "Uzbekistan"
  },
  "vanuatu": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/vanuatu/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/vanuatu/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/vanuatu/flag.png",
    "nom_fr": "Vanuatu",
    "nom_en": "Vanuatu",
    "nom_de": "Vanuatu",
    "nom_es": "Vanuatu",
    "nom_pt": "Vanuatu",
    "nom_it": "Vanuatu",
    "nom_nl": "Vanuatu",
    "nom_sv": "Vanuatu",
    "nom_da": "Vanuatu",
    "nom_no": "Vanuatu",
    "nom_fi": "Vanuatu"
  },
  "venezuela": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/venezuela/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/venezuela/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/venezuela/flag.png",
    "nom_fr": "Venezuela",
    "nom_en": "Venezuela",
    "nom_de": "Venezuela",
    "nom_es": "Venezuela",
    "nom_pt": "Venezuela",
    "nom_it": "Venezuela",
    "nom_nl": "Venezuela",
    "nom_sv": "Venezuela",
    "nom_da": "Venezuela",
    "nom_no": "Venezuela",
    "nom_fi": "Venezuela"
  },
  "vietnam": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/vietnam/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/vietnam/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/vietnam/flag.png",
    "nom_fr": "Viêt Nam",
    "nom_en": "Vietnam",
    "nom_de": "Vietnam",
    "nom_es": "Vietnam",
    "nom_pt": "Vietname",
    "nom_it": "Vietnam",
    "nom_nl": "Vietnam",
    "nom_sv": "Vietnam",
    "nom_da": "Vietnam",
    "nom_no": "Vietnam",
    "nom_fi": "Vietnam"
  },
  "yemen": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/yemen/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/yemen/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/yemen/flag.png",
    "nom_fr": "Yémen",
    "nom_en": "Yemen",
    "nom_de": "Jemen",
    "nom_es": "Yemen",
    "nom_pt": "Iémen",
    "nom_it": "Yemen",
    "nom_nl": "Jemen",
    "nom_sv": "Jemen",
    "nom_da": "Jemen",
    "nom_no": "Jemen",
    "nom_fi": "Jemen"
  },
  "zambia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/zambia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/zambia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/zambia/flag.png",
    "nom_fr": "Zambie",
    "nom_en": "Zambia",
    "nom_de": "Sambia",
    "nom_es": "Zambia",
    "nom_pt": "Zâmbia",
    "nom_it": "Zambia",
    "nom_nl": "Zambia",
    "nom_sv": "Zambia",
    "nom_da": "Zambia",
    "nom_no": "Zambia",
    "nom_fi": "Sambia"
  },
  "zimbabwe": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/zimbabwe/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/zimbabwe/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/zimbabwe/flag.png",
    "nom_fr": "Zimbabwe",
    "nom_en": "Zimbabwe",
    "nom_de": "Simbabwe",
    "nom_es": "Zimbabue",
    "nom_pt": "Zimbábue",
    "nom_it": "Zimbabwe",
    "nom_nl": "Zimbabwe",
    "nom_sv": "Zimbabwe",
    "nom_da": "Zimbabwe",
    "nom_no": "Zimbabwe",
    "nom_fi": "Zimbabwe"
  },
  "equatorial-guineaa": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/equatorial-guineaa/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/equatorial-guineaa/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/equatorial-guineaa/flag.png",
    "nom_fr": "Guinée Equatoriale",
    "nom_en": "Equatorial Guinea",
    "nom_de": "Äquatorialguinea",
    "nom_es": "Guinea Ecuatorial",
    "nom_pt": "Guiné Equatorial",
    "nom_it": "Guinea Equatoriale",
    "nom_nl": "Equatoriaal-Guinea",
    "nom_sv": "Ekvatorialguinea",
    "nom_da": "Ækvatorialguinea",
    "nom_no": "Ekvatorial-Guinea",
    "nom_fi": "Päiväntasaajan Guinea"
  },
  "fidji": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/fidji/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/fidji/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/fidji/flag.png",
    "nom_fr": "Fidji",
    "nom_en": "Fiji",
    "nom_de": "Fidschi",
    "nom_es": "Fiyi",
    "nom_pt": "Fiji",
    "nom_it": "Fiji",
    "nom_nl": "Fiji",
    "nom_sv": "Fiji",
    "nom_da": "Fiji",
    "nom_no": "Fiji",
    "nom_fi": "Fidži"
  },
  "mongolia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mongolia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mongolia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/mongolia/flag.png",
    "nom_fr": "Mongolie",
    "nom_en": "Mongolia",
    "nom_de": "Mongolei",
    "nom_es": "Mongolia",
    "nom_pt": "Mongólia",
    "nom_it": "Mongolia",
    "nom_nl": "Mongolië",
    "nom_sv": "Mongoliet",
    "nom_da": "Mongoliet",
    "nom_no": "Mongolia",
    "nom_fi": "Mongolia"
  },
  "new-zealand": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/new-zealand/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/new-zealand/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/new-zealand/flag.png",
    "nom_fr": "Nouvelle-Zélande",
    "nom_en": "New Zealand",
    "nom_de": "Neuseeland",
    "nom_es": "Nueva Zelanda",
    "nom_pt": "Nova Zelândia",
    "nom_it": "Nuova Zelanda",
    "nom_nl": "Nieuw-Zeeland",
    "nom_sv": "Nya Zeeland",
    "nom_da": "New Zealand",
    "nom_no": "New Zealand",
    "nom_fi": "Uusi-Seelanti"
  },
  "northern-ireland": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/northern-ireland/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/northern-ireland/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/northern-ireland/flag.png",
    "nom_fr": "Irlande du Nord",
    "nom_en": "Northern Ireland",
    "nom_de": "Nordirland",
    "nom_es": "Irlanda del Norte",
    "nom_pt": "Irlanda do Norte",
    "nom_it": "Irlanda del Nord",
    "nom_nl": "Noord-Ierland",
    "nom_sv": "Nordirland",
    "nom_da": "Nordirland",
    "nom_no": "Nord-Irland",
    "nom_fi": "Pohjois-Irlanti"
  },
  "porto-rico": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/porto-rico/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/porto-rico/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/porto-rico/flag.png",
    "nom_fr": "Porto Rico",
    "nom_en": "Puerto Rico",
    "nom_de": "Puerto Rico",
    "nom_es": "Puerto Rico",
    "nom_pt": "Porto Rico",
    "nom_it": "Porto Rico",
    "nom_nl": "Puerto Rico",
    "nom_sv": "Puerto Rico",
    "nom_da": "Puerto Rico",
    "nom_no": "Puerto Rico",
    "nom_fi": "Puerto Rico"
  },
  "republic-congo": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/congo/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/congo/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/congo/flag.png",
    "nom_fr": "République du Congo",
    "nom_en": "Republic of the Congo",
    "nom_de": "Republik Kongo",
    "nom_es": "República del Congo",
    "nom_pt": "República do Congo",
    "nom_it": "Repubblica del Congo",
    "nom_nl": "Republiek Congo",
    "nom_sv": "Republiken Kongo",
    "nom_da": "Republikken Congo",
    "nom_no": "Republikken Congo",
    "nom_fi": "Kongon tasavalta"
  },
  "saint-lucia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saint-lucia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saint-lucia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/saint-lucia/flag.png",
    "nom_fr": "Sainte Lucie",
    "nom_en": "Saint Lucia",
    "nom_de": "St. Lucia",
    "nom_es": "Santa Lucía",
    "nom_pt": "Santa Lúcia",
    "nom_it": "Santa Lucia",
    "nom_nl": "Saint Lucia",
    "nom_sv": "Sankta Lucia",
    "nom_da": "Saint Lucia",
    "nom_no": "St. Lucia",
    "nom_fi": "Saint Lucia"
  },
  "south-sudan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-sudan/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-sudan/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/south-sudan/flag.png",
    "nom_fr": "Soudan du Sud",
    "nom_en": "South Sudan",
    "nom_de": "Südsudan",
    "nom_es": "Sudán del Sur",
    "nom_pt": "Sudão do Sul",
    "nom_it": "Sudan del Sud",
    "nom_nl": "Zuid-Soedan",
    "nom_sv": "Sydsudan",
    "nom_da": "Sydsudan",
    "nom_no": "Sør-Sudan",
    "nom_fi": "Etelä-Sudan"
  },
  "nepal": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nepal/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nepal/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/nepal/flag.png",
    "nom_fr": "Népal",
    "nom_en": "Nepal",
    "nom_de": "Nepal",
    "nom_es": "Nepal",
    "nom_pt": "Nepal",
    "nom_it": "Nepal",
    "nom_nl": "Nepal",
    "nom_sv": "Nepal",
    "nom_da": "Nepal",
    "nom_no": "Nepal",
    "nom_fi": "Nepal"
  },
  "panama": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/panama/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/panama/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/panama/flag.png",
    "nom_fr": "Panama",
    "nom_en": "Panama",
    "nom_de": "Panama",
    "nom_es": "Panamá",
    "nom_pt": "Panamá",
    "nom_it": "Panama",
    "nom_nl": "Panama",
    "nom_sv": "Panama",
    "nom_da": "Panama",
    "nom_no": "Panama",
    "nom_fi": "Panama"
  },
  "new-caledonia": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/new-caledonia/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/new-caledonia/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/new-caledonia/flag.png",
    "nom_fr": "Nouvelle Calédonie",
    "nom_en": "New Caledonia",
    "nom_de": "Neukaledonien",
    "nom_es": "Nueva Caledonia",
    "nom_pt": "Nova Caledónia",
    "nom_it": "Nuova Caledonia",
    "nom_nl": "Nieuw-Caledonië",
    "nom_sv": "Nya Kaledonien",
    "nom_da": "Ny Kaledonien",
    "nom_no": "Ny-Caledonia",
    "nom_fi": "Uusi-Kaledonia"
  },
  "kurdistan": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kurdistan2/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kurdistan2/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/kurdistan2/flag.png",
    "nom_fr": "Kurdistan",
    "nom_en": "Kurdistan",
    "nom_de": "Kurdistan",
    "nom_es": "Kurdistán",
    "nom_pt": "Curdistão",
    "nom_it": "Kurdistan",
    "nom_nl": "Koerdistan",
    "nom_sv": "Kurdistan",
    "nom_da": "Kurdistan",
    "nom_no": "Kurdistan",
    "nom_fi": "Kurdistani"
  },
  "wales": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/wales/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/wales/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/wales/flag.png",
    "nom_fr": "Pays de Galles",
    "nom_en": "Wales",
    "nom_de": "Wales",
    "nom_es": "Gales",
    "nom_pt": "País de Gales",
    "nom_it": "Galles",
    "nom_nl": "Wales",
    "nom_sv": "Wales",
    "nom_da": "Wales",
    "nom_no": "Wales",
    "nom_fi": "Wales"
  },
  "Bouches-du-Rhône": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Bouches-du-Rh%C3%B4ne/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Bouches-du-Rh%C3%B4ne/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Bouches-du-Rh%C3%B4ne/flag.png",
    "nom_fr": "Bouches-du-Rhône",
    "nom_en": "Bouches-du-Rhône",
    "nom_de": "Bouches-du-Rhône",
    "nom_es": "Bocas del Ródano",
    "nom_pt": "Bocas do Ródano",
    "nom_it": "Bocche del Rodano",
    "nom_nl": "Bouches-du-Rhône",
    "nom_sv": "Bouches-du-Rhône",
    "nom_da": "Bouches-du-Rhône",
    "nom_no": "Bouches-du-Rhône",
    "nom_fi": "Bouches-du-Rhône"
  },
  "Dominique": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Dominique/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Dominique/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Dominique/flag.png",
    "nom_fr": "Dominique",
    "nom_en": "Dominica",
    "nom_de": "Dominica",
    "nom_es": "Dominica",
    "nom_pt": "Dominica",
    "nom_it": "Dominica",
    "nom_nl": "Dominica",
    "nom_sv": "Dominica",
    "nom_da": "Dominica",
    "nom_no": "Dominica",
    "nom_fi": "Dominica"
  },
  "Île-de-France": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/%C3%8Ele-de-France/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/%C3%8Ele-de-France/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/%C3%8Ele-de-France/flag.png",
    "nom_fr": "Île-de-France",
    "nom_en": "Île-de-France",
    "nom_de": "Île-de-France",
    "nom_es": "Isla de Francia",
    "nom_pt": "Ilha de França",
    "nom_it": "Isola di Francia",
    "nom_nl": "Île-de-France",
    "nom_sv": "Île-de-France",
    "nom_da": "Île-de-France",
    "nom_no": "Île-de-France",
    "nom_fi": "Île-de-France"
  },
  "Provence-Alpes-Côte d'Azur": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Provence-Alpes-C%C3%B4te%20d'Azur/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Provence-Alpes-C%C3%B4te%20d'Azur/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Provence-Alpes-C%C3%B4te%20d'Azur/flag.png",
    "nom_fr": "Provence-Alpes-Côte d'Azur",
    "nom_en": "Provence-Alpes-Côte d'Azur",
    "nom_de": "Provence-Alpes-Côte d'Azur",
    "nom_es": "Provenza-Alpes-Costa Azul",
    "nom_pt": "Provença-Alpes-Costa Azul",
    "nom_it": "Provenza-Alpi-Costa Azzurra",
    "nom_nl": "Provence-Alpes-Côte d'Azur",
    "nom_sv": "Provence-Alpes-Côte d'Azur",
    "nom_da": "Provence-Alpes-Côte d'Azur",
    "nom_no": "Provence-Alpes-Côte d'Azur",
    "nom_fi": "Provence-Alpes-Côte d'Azur"
  },
  "Nouvelle-Calédonie": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Nouvelle-Cal%C3%A9donie/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Nouvelle-Cal%C3%A9donie/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Nouvelle-Cal%C3%A9donie/flag.png",
    "nom_fr": "Nouvelle-Calédonie",
    "nom_en": "New Caledonia",
    "nom_de": "Neukaledonien",
    "nom_es": "Nueva Caledonia",
    "nom_pt": "Nova Caledónia",
    "nom_it": "Nuova Caledonia",
    "nom_nl": "Nieuw-Caledonië",
    "nom_sv": "Nya Kaledonien",
    "nom_da": "Ny Kaledonien",
    "nom_no": "Ny-Caledonia",
    "nom_fi": "Uusi-Kaledonia"
  },
  "Quebec": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Quebec/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Quebec/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Quebec/flag.png",
    "nom_fr": "Quebec",
    "nom_en": "Quebec",
    "nom_de": "Québec",
    "nom_es": "Quebec",
    "nom_pt": "Quebec",
    "nom_it": "Québec",
    "nom_nl": "Quebec",
    "nom_sv": "Québec",
    "nom_da": "Quebec",
    "nom_no": "Québec",
    "nom_fi": "Quebec"
  },
  "Tamil-Eelam": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Tamil-Eelam/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Tamil-Eelam/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Tamil-Eelam/flag.png",
    "nom_fr": "Tamil Eelam",
    "nom_en": "Tamil Eelam",
    "nom_de": "Tamil Eelam",
    "nom_es": "Tamil Eelam",
    "nom_pt": "Tamil Eelam",
    "nom_it": "Tamil Eelam",
    "nom_nl": "Tamil Eelam",
    "nom_sv": "Tamil Eelam",
    "nom_da": "Tamil Eelam",
    "nom_no": "Tamil Eelam",
    "nom_fi": "Tamil Eelam"
  },
  "Normandie": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Normandie/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Normandie/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Normandie/flag.png",
    "nom_fr": "Normandie",
    "nom_en": "Normandy",
    "nom_de": "Normandie",
    "nom_es": "Normandía",
    "nom_pt": "Normandia",
    "nom_it": "Normandie",
    "nom_nl": "Normandië",
    "nom_sv": "Normandie",
    "nom_da": "Normandiet",
    "nom_no": "Normandie",
    "nom_fi": "Normandia"
  },
  "Catalogne": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/catalogne/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/catalogne/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/catalogne/flag.png",
    "nom_fr": "Catalogne",
    "nom_en": "Catalonia",
    "nom_de": "Katalonien",
    "nom_es": "Cataluña",
    "nom_pt": "Catalunha",
    "nom_it": "Catalogna",
    "nom_nl": "Catalonië",
    "nom_sv": "Katalonien",
    "nom_da": "Katalonien",
    "nom_no": "Catalonia",
    "nom_fi": "Katalonia"
  },
  "wallis-et-futuna": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/wallis-et-futuna/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/wallis-et-futuna/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/futuna/flag.png",
    "nom_fr": "Wallis et Futuna",
    "nom_en": "Wallis and Futuna",
    "nom_de": "Wallis und Futuna",
    "nom_es": "Wallis y Futuna",
    "nom_pt": "Wallis e Futuna",
    "nom_it": "Wallis e Futuna",
    "nom_nl": "Wallis en Futuna",
    "nom_sv": "Wallis- och Futunaöarna",
    "nom_da": "Wallis og Futuna",
    "nom_no": "Wallis og Futuna",
    "nom_fi": "Wallis ja Futuna"
  },
  "Auvergne-Rhône-Alpes": {
    "front": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Auvergne-Rh%C3%B4ne-Alpes/front.png",
    "back": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Auvergne-Rh%C3%B4ne-Alpes/back.png",
    "flag": "https://cdn.jsdelivr.net/gh/laureaubaptiste/maillotsbinationaux/jerseys/Auvergne-Rh%C3%B4ne-Alpes/flag.png",
    "nom_fr": "Auvergne-Rhône-Alpes",
    "nom_en": "Auvergne-Rhône-Alpes",
    "nom_de": "Auvergne-Rhône-Alpes",
    "nom_es": "Auvernia-Ródano-Alpes",
    "nom_pt": "Alvernha-Ródano-Alpes",
    "nom_it": "Alvernia-Rodano-Alpi",
    "nom_nl": "Auvergne-Rhône-Alpes",
    "nom_sv": "Auvergne-Rhône-Alpes",
    "nom_da": "Auvergne-Rhône-Alpes",
    "nom_no": "Auvergne-Rhône-Alpes",
    "nom_fi": "Auvergne-Rhône-Alpes"
  }
};

window.countryGroups = {
  "france": ["alsace","auvergne", "Auvergne-Rhône-Alpes","Bouches-du-Rhône","bretagne","corse","guadeloupe","guyane française","Île-de-France","lorraine","martinique","mayotte","nord-pas-de-calais","Nouvelle-Calédonie","Normandie","pays-basque","picardie","Provence-Alpes-Côte d'Azur","reunion","savoie", "wallis-et-futuna"],
  "algeria": ["chaoui","kabylie","tuareg"],
  "morocco": ["chleuh","rif"],
  "canada": ["Quebec"],
  "sri-lanka": ["Tamil-Eelam"],
  "spain": ["Catalogne"]
};